var _style, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComputer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "animated",
    id: "freepik_stories-data-extraction",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750 500",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsSvgjs: "http://svgjs.com/svgjs",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "svg#freepik_stories-data-extraction:not(.animated) .animable {opacity: 0;}svg#freepik_stories-data-extraction.animated #freepik--background-complete--inject-517 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) zoomOut;animation-delay: 0s;}svg#freepik_stories-data-extraction.animated #freepik--Table--inject-517 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) fadeIn;animation-delay: 0s;}svg#freepik_stories-data-extraction.animated #freepik--Server--inject-517 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) lightSpeedLeft;animation-delay: 0s;}svg#freepik_stories-data-extraction.animated #freepik--Device--inject-517 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideRight;animation-delay: 0s;}svg#freepik_stories-data-extraction.animated #freepik--Plant--inject-517 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideLeft;animation-delay: 0s;}svg#freepik_stories-data-extraction.animated #freepik--Files--inject-517 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideRight;animation-delay: 0s;}svg#freepik_stories-data-extraction.animated #freepik--Folder--inject-517 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) zoomOut;animation-delay: 0s;}svg#freepik_stories-data-extraction.animated #freepik--magnifying-glass--inject-517 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) lightSpeedLeft;animation-delay: 0s;}            @keyframes zoomOut {                0% {                    opacity: 0;                    transform: scale(1.5);                }                100% {                    opacity: 1;                    transform: scale(1);                }            }                    @keyframes fadeIn {                0% {                    opacity: 0;                }                100% {                    opacity: 1;                }            }                    @keyframes lightSpeedLeft {              from {                transform: translate3d(-50%, 0, 0) skewX(20deg);                opacity: 0;              }              60% {                transform: skewX(-10deg);                opacity: 1;              }              80% {                transform: skewX(2deg);              }              to {                opacity: 1;                transform: translate3d(0, 0, 0);              }            }                    @keyframes slideRight {                0% {                    opacity: 0;                    transform: translateX(30px);                }                100% {                    opacity: 1;                    transform: translateX(0);                }            }                    @keyframes slideLeft {                0% {                    opacity: 0;                    transform: translateX(-30px);                }                100% {                    opacity: 1;                    transform: translateX(0);                }            }        ")), /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-517",
    className: "animable",
    style: {
      transformOrigin: "375.005px 222.035px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M677.37,304.23l-13.12.27-6.66.12c-2.23,0-4.47,0-6.7.05h-.44v-.44L650.39,293v-.5h.5l13.24.06c4.42,0,8.83.11,13.24.16h.28V293c0,1.9-.08,3.78-.13,5.65Zm0,0-.14-5.66c-.05-1.86-.11-3.7-.13-5.53l.27.27c-4.41.05-8.82.16-13.24.16l-13.24.07.5-.5,0,11.19-.45-.45c2.18,0,4.36,0,6.55.05L664,304Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "664.02px 298.585px"
    },
    id: "eld63zzxassaf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 636.12,
    y: 307.15,
    width: 26.48,
    height: 11.19,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "649.36px 312.745px"
    },
    id: "elpe957frsaa",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M692.14,318.33l-13.12.28-6.66.11c-2.23,0-4.47,0-6.7.06h-.44v-.45l-.06-11.18v-.51h.5l13.24.06c4.42,0,8.83.11,13.24.16h.28v.27c0,1.89-.09,3.78-.13,5.65Zm0,0-.14-5.65c0-1.86-.11-3.7-.13-5.53l.27.27c-4.41.05-8.82.16-13.24.16l-13.24.06.5-.49,0,11.18-.45-.44c2.19,0,4.36,0,6.55.05l6.58.12Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "678.79px 312.71px"
    },
    id: "elc52wg4qpedk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 274.41,
    y: 97.21,
    width: 26.48,
    height: 11.19,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "287.65px 102.805px"
    },
    id: "eld6iu22akj05",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.12,122.51l-13.12.28-6.67.11c-2.22,0-4.46,0-6.69,0h-.44v-.45l-.05-11.19v-.5h.5l13.24.06c4.41,0,8.83.12,13.24.17h.28v.27c0,1.9-.08,3.79-.13,5.65Zm0,0-.14-5.65c-.05-1.87-.11-3.71-.13-5.54l.27.27c-4.41,0-8.83.16-13.24.17l-13.24.06.5-.5-.05,11.19-.45-.45c2.18,0,4.36,0,6.55.06l6.57.11Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "272.78px 116.83px"
    },
    id: "el26nusbrcsn6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.66,122.51l-13.12.28-6.66.11c-2.23,0-4.47,0-6.7,0h-.44v-.45l-.06-11.19v-.5h.5l13.24.06c4.42,0,8.83.12,13.24.17h.28v.27c0,1.9-.09,3.79-.13,5.65Zm0,0-.14-5.65c0-1.87-.11-3.71-.13-5.54l.27.27c-4.41,0-8.82.16-13.24.17l-13.24.06.5-.5-.05,11.19-.45-.45c2.18,0,4.36,0,6.55.06l6.58.11Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "302.31px 116.83px"
    },
    id: "elroea6gd7nvp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120.61,
    y: 278.89,
    width: 26.48,
    height: 11.19,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "133.85px 284.485px"
    },
    id: "eloirxnoheih",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.86,171.07l-13.12.28-6.66.11c-2.23,0-4.47,0-6.7.06h-.44v-.45l-.06-11.19v-.5h.5l13.24.07c4.42,0,8.83.11,13.24.16h.28v.27c0,1.9-.08,3.79-.13,5.66Zm0,0-.14-5.65c-.05-1.86-.11-3.71-.13-5.54l.27.28c-4.41.05-8.82.15-13.24.16l-13.24.06.5-.5-.05,11.19-.45-.44c2.18,0,4.36,0,6.55.05l6.58.11Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "509.51px 165.45px"
    },
    id: "elqyk8v53bygk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 649.36,
    y: 51.21,
    width: 26.48,
    height: 11.19,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "662.6px 56.805px"
    },
    id: "el8crnh36w0s8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M690.61,76.51l-13.12.28-6.66.11c-2.23,0-4.47,0-6.7.06h-.44v-.45l-.06-11.19v-.5h.5l13.24.07c4.42,0,8.83.11,13.24.16h.28v.27c0,1.9-.09,3.79-.14,5.66Zm0,0-.14-5.65c0-1.86-.11-3.71-.13-5.54l.27.28c-4.41.05-8.82.15-13.24.16l-13.24.06.5-.5,0,11.19-.45-.44c2.18,0,4.36,0,6.55.05l6.58.11Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "677.26px 70.89px"
    },
    id: "elmhwzaqzukpr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 57.86,
    y: 51.23,
    width: 26.48,
    height: 11.19,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "71.1px 56.825px"
    },
    id: "el4bn9noxeo8j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.38,256l-5.89,9.49,2.91,1.8a2.66,2.66,0,0,1,1.23,2.5,15.45,15.45,0,0,0-.05,1.67,2.66,2.66,0,0,1-1.39,2.41l-3,1.61,5.28,9.85,3-1.62a2.68,2.68,0,0,1,2.78.18,12.92,12.92,0,0,0,1.42.88,2.67,2.67,0,0,1,1.4,2.41L71,290.61l11.16.34.1-3.42a2.67,2.67,0,0,1,1.56-2.32c.25-.11.49-.24.73-.37l.72-.4a2.63,2.63,0,0,1,2.77,0l2.93,1.81,5.89-9.49-2.92-1.81a2.68,2.68,0,0,1-1.23-2.5,15.26,15.26,0,0,0,.06-1.66,2.67,2.67,0,0,1,1.38-2.41l3-1.61-5.28-9.85-3,1.62a2.66,2.66,0,0,1-2.77-.18,13.71,13.71,0,0,0-1.41-.87,2.64,2.64,0,0,1-1.4-2.41l.1-3.43-11.16-.34-.11,3.42a2.63,2.63,0,0,1-1.55,2.3l-.74.38-.72.4a2.63,2.63,0,0,1-2.78,0Zm9.45,7.05a9.15,9.15,0,1,1-3.74,12.38A9.14,9.14,0,0,1,72.83,263.06Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "77.17px 271.13px"
    },
    id: "elnwl1677lez",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665,81.05,669,87.82,671,86.63a1.87,1.87,0,0,1,2,.06,11.12,11.12,0,0,0,1,.59,1.87,1.87,0,0,1,1,1.65v2.4h7.82v-2.4a1.87,1.87,0,0,1,1-1.65c.35-.18.69-.38,1-.59a1.85,1.85,0,0,1,2-.06l2.07,1.19,3.91-6.77-2.08-1.2a1.85,1.85,0,0,1-.91-1.73c0-.19,0-.38,0-.57s0-.39,0-.58a1.84,1.84,0,0,1,.9-1.72L692.82,74l-3.91-6.77-2.08,1.2a1.87,1.87,0,0,1-2-.07,11.12,11.12,0,0,0-1-.59,1.87,1.87,0,0,1-1-1.65V63.77H675v2.39a1.85,1.85,0,0,1-1,1.65c-.35.18-.68.38-1,.59a1.87,1.87,0,0,1-2,.07L669,67.27,665,74l2.08,1.2A1.88,1.88,0,0,1,668,77c0,.19,0,.38,0,.58s0,.38,0,.57a1.85,1.85,0,0,1-.91,1.73Zm7.48-3.5A6.41,6.41,0,1,1,678.93,84,6.41,6.41,0,0,1,672.52,77.55Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "678.91px 77.55px"
    },
    id: "elcmezf3kmgdg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.48,148.92A30.47,30.47,0,1,0,583,118.45,30.47,30.47,0,0,0,613.48,148.92Zm0-44.7a14.23,14.23,0,1,1-14.24,14.23A14.23,14.23,0,0,1,613.48,104.22Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "613.47px 118.45px"
    },
    id: "el3ho5ofvhinu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "607.62 147.66 619.34 147.66 618.69 155.95 608.27 155.95 607.62 147.66",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "613.48px 151.805px"
    },
    id: "elg38dir9hz7m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "629.92 143.71 638.21 135.43 643.62 141.75 636.25 149.12 629.92 143.71",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "636.77px 142.275px"
    },
    id: "elzlcwbdu87un",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "642.9 125.15 642.9 113.43 651.2 114.08 651.2 124.5 642.9 125.15",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "647.05px 119.29px"
    },
    id: "el6ljejkpdt8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "638.96 102.84 630.67 94.56 636.99 89.15 644.36 96.52 638.96 102.84",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "637.515px 95.995px"
    },
    id: "elckivkqgn6pd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "620.39 89.86 608.67 89.86 609.32 81.57 619.74 81.57 620.39 89.86",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "614.53px 85.715px"
    },
    id: "elvxccqrpk8q",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "598.09 93.81 589.8 102.1 584.39 95.78 591.76 88.41 598.09 93.81",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "591.24px 95.255px"
    },
    id: "el2tjdra4ktp3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "585.11 112.38 585.11 124.09 576.81 123.45 576.81 113.02 585.11 112.38",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "580.96px 118.235px"
    },
    id: "eloy5i3z8nq5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "589.06 134.68 597.34 142.97 591.02 148.37 583.65 141 589.06 134.68",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "590.495px 141.525px"
    },
    id: "el8pmqka7eo6v",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147,98.19A31.55,31.55,0,1,1,115.77,62V93.57Z",
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "115.622px 93.55px"
    },
    id: "el3288ues80xu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.74,87.14a30.68,30.68,0,0,1-.34,4.63l-31.2-4.63V55.59a31.51,31.51,0,0,1,31.54,31.55Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "137.97px 73.68px"
    },
    id: "el5z5jhxxiytv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.77,
    y: 110.54,
    width: 33.55,
    height: 1,
    style: {
      fill: "rgb(199, 199, 199)",
      transformOrigin: "148.545px 111.04px"
    },
    id: "el1r1je3syafg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.68,113.89a2.86,2.86,0,1,1,2.85-2.85A2.86,2.86,0,0,1,167.68,113.89Zm0-4.71a1.86,1.86,0,1,0,1.85,1.86A1.86,1.86,0,0,0,167.68,109.18Z",
    style: {
      fill: "rgb(199, 199, 199)",
      transformOrigin: "167.67px 111.03px"
    },
    id: "el4etv0dezwzp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176.2,
    y: 109.27,
    width: 26.06,
    height: 1.18,
    style: {
      fill: "rgb(199, 199, 199)",
      transformOrigin: "189.23px 109.86px"
    },
    id: "el9uyg47rryfk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176.2,
    y: 111.62,
    width: 14.75,
    height: 1.18,
    style: {
      fill: "rgb(199, 199, 199)",
      transformOrigin: "183.575px 112.21px"
    },
    id: "elqi8keyxkes",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 585.11,
    y: 337.76,
    width: 7.72,
    height: 54.95,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "588.97px 365.235px"
    },
    id: "elklwz5tjrrtq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 598.38,
    y: 351.06,
    width: 7.72,
    height: 41.65,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "602.24px 371.885px"
    },
    id: "elab8mqdjkgd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 611.65,
    y: 371.89,
    width: 7.72,
    height: 20.82,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "615.51px 382.3px"
    },
    id: "el7hpk894od8y",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 624.92,
    y: 359.99,
    width: 7.72,
    height: 32.72,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "628.78px 376.35px"
    },
    id: "eltdhgho6myqp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 638.2,
    y: 347.5,
    width: 7.72,
    height: 45.21,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "642.06px 370.105px"
    },
    id: "el0u9cemwoevlh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 651.47,
    y: 340.16,
    width: 7.72,
    height: 52.55,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "655.33px 366.435px"
    },
    id: "el80p1s20xmtg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.63,330.78l.09,15.48,0,15.48.06,31-.2-.2q10.65,0,21.29,0l21.29,0,21.29.05,21.29.11-21.29.11-21.29.05-21.29,0q-10.65,0-21.29,0h-.19v-.19l.06-31,0-15.48Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "623.065px 361.82px"
    },
    id: "ely4h0nkg5tec",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.93,333.88a6.2,6.2,0,0,1,1.7-.22,6.27,6.27,0,0,1,1.71.22,6.27,6.27,0,0,1-1.71.22A6.2,6.2,0,0,1,578.93,333.88Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "580.635px 333.88px"
    },
    id: "elehm2zpoagck",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.93,338.59a6.2,6.2,0,0,1,1.7-.22,5.91,5.91,0,0,1,1.71.22,6.27,6.27,0,0,1-1.71.22A6.2,6.2,0,0,1,578.93,338.59Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "580.635px 338.59px"
    },
    id: "elv5ynv0drf6q",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.93,343.29a5.83,5.83,0,0,1,1.7-.21,5.89,5.89,0,0,1,1.71.21,5.58,5.58,0,0,1-1.71.22A5.52,5.52,0,0,1,578.93,343.29Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "580.635px 343.295px"
    },
    id: "eljcwiiu2nzbd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.93,348a6.2,6.2,0,0,1,1.7-.22,6.27,6.27,0,0,1,1.71.22,6.27,6.27,0,0,1-1.71.22A6.2,6.2,0,0,1,578.93,348Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "580.635px 348px"
    },
    id: "el136w5hpsgenc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.93,352.71a6.2,6.2,0,0,1,1.7-.22,6.27,6.27,0,0,1,1.71.22,6.27,6.27,0,0,1-1.71.22A6.2,6.2,0,0,1,578.93,352.71Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "580.635px 352.71px"
    },
    id: "el8e5asrp8ag",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.93,357.42a5.52,5.52,0,0,1,1.7-.22,5.58,5.58,0,0,1,1.71.22,5.89,5.89,0,0,1-1.71.21A5.83,5.83,0,0,1,578.93,357.42Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "580.635px 357.415px"
    },
    id: "elwt1u54p0j7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.93,362.12a6.2,6.2,0,0,1,1.7-.22,6.27,6.27,0,0,1,1.71.22,5.58,5.58,0,0,1-1.71.22A6.2,6.2,0,0,1,578.93,362.12Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "580.635px 362.121px"
    },
    id: "el0jhp96jmx4uc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.93,366.83a6.2,6.2,0,0,1,1.7-.22,6.27,6.27,0,0,1,1.71.22,6.27,6.27,0,0,1-1.71.22A6.2,6.2,0,0,1,578.93,366.83Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "580.635px 366.83px"
    },
    id: "el8f7r6k63eat",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.93,371.54a5.84,5.84,0,0,1,1.7-.22,5.58,5.58,0,0,1,1.71.22,6.27,6.27,0,0,1-1.71.22A6.2,6.2,0,0,1,578.93,371.54Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "580.635px 371.539px"
    },
    id: "el7s8kn6quiuc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.93,376.24a5.83,5.83,0,0,1,1.7-.21,5.89,5.89,0,0,1,1.71.21,5.58,5.58,0,0,1-1.71.22A5.52,5.52,0,0,1,578.93,376.24Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "580.635px 376.245px"
    },
    id: "eloffdeqdscbj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.93,381a6.2,6.2,0,0,1,1.7-.22,6.27,6.27,0,0,1,1.71.22,6.27,6.27,0,0,1-1.71.22A6.2,6.2,0,0,1,578.93,381Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "580.635px 381px"
    },
    id: "elkfp9lsouzpp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.93,385.66a6.2,6.2,0,0,1,1.7-.22,5.58,5.58,0,0,1,1.71.22,6.27,6.27,0,0,1-1.71.22A6.2,6.2,0,0,1,578.93,385.66Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "580.635px 385.659px"
    },
    id: "elwcamupv5yb",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Table--inject-517",
    className: "animable",
    style: {
      transformOrigin: "375px 437.25px"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "50.72 437.25 131.79 437.01 212.86 436.92 375 436.75 537.14 436.92 618.21 437.01 699.28 437.25 618.21 437.5 537.14 437.59 375 437.75 212.86 437.58 131.79 437.5 50.72 437.25",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "375px 437.25px"
    },
    id: "elaytxkx6ge",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Server--inject-517",
    className: "animable",
    style: {
      transformOrigin: "108.66px 372.81px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "el3nfx9sj5r1n"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 59.19,
    y: 308.36,
    width: 105.85,
    height: 128.9,
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "112.115px 372.81px",
      transform: "rotate(180deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el8ay59no1mke"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49.03,
    y: 312.63,
    width: 94.29,
    height: 26.4,
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "96.175px 325.83px",
      transform: "rotate(180deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 143.33,
    y: 312.63,
    width: 24.96,
    height: 26.4,
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "155.81px 325.83px"
    },
    id: "el1r2nfl19h3z",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elj4vspjv9nzb"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 93.47,
    y: 316.99,
    width: 45.05,
    height: 2.23,
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "115.995px 318.105px",
      transform: "rotate(180deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el6z8t6ywbape"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 93.47,
    y: 320.85,
    width: 45.05,
    height: 2.23,
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "115.995px 321.965px",
      transform: "rotate(180deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elh3rx8vv8keq"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 93.47,
    y: 324.72,
    width: 45.05,
    height: 2.23,
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "115.995px 325.835px",
      transform: "rotate(180deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elkyxf2mg14oj"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 93.47,
    y: 328.58,
    width: 45.05,
    height: 2.23,
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "115.995px 329.695px",
      transform: "rotate(180deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elsdijlulwa0g"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 93.47,
    y: 332.44,
    width: 45.05,
    height: 2.23,
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "115.995px 333.555px",
      transform: "rotate(180deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 83.82,
    cy: 319.2,
    r: 2.21,
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "83.82px 319.2px"
    },
    id: "elyfxzzrgh8qg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.32,319.2A2.21,2.21,0,1,0,76.53,317,2.21,2.21,0,0,0,74.32,319.2Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "76.53px 319.21px"
    },
    id: "elyq8w2wojj9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67,319.2A2.21,2.21,0,1,0,69.25,317,2.2,2.2,0,0,0,67,319.2Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "69.21px 319.21px"
    },
    id: "elp8p07bgv779",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.75,319.2A2.21,2.21,0,1,0,62,317,2.21,2.21,0,0,0,59.75,319.2Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "61.96px 319.21px"
    },
    id: "eluub1agrkoss",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.46,319.2A2.21,2.21,0,1,0,54.67,317,2.21,2.21,0,0,0,52.46,319.2Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "54.67px 319.21px"
    },
    id: "elq1qhvmszf3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.61,325.83a2.21,2.21,0,1,0,2.21-2.21A2.21,2.21,0,0,0,81.61,325.83Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "83.82px 325.83px"
    },
    id: "el7gz88peqteq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.32,325.83a2.21,2.21,0,1,0,2.21-2.21A2.21,2.21,0,0,0,74.32,325.83Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "76.53px 325.83px"
    },
    id: "el21jplwpbi2c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67,325.83a2.21,2.21,0,1,0,2.21-2.21A2.2,2.2,0,0,0,67,325.83Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "69.21px 325.83px"
    },
    id: "eloo3fvcire88",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.75,325.83A2.21,2.21,0,1,0,62,323.62,2.21,2.21,0,0,0,59.75,325.83Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "61.96px 325.83px"
    },
    id: "el68d42j579u6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.46,325.83a2.21,2.21,0,1,0,2.21-2.21A2.21,2.21,0,0,0,52.46,325.83Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "54.67px 325.83px"
    },
    id: "elxi1rlnczac",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.61,332.46a2.21,2.21,0,1,0,2.21-2.21A2.21,2.21,0,0,0,81.61,332.46Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "83.82px 332.46px"
    },
    id: "elbc0phdoa3h7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.32,332.46a2.21,2.21,0,1,0,2.21-2.21A2.21,2.21,0,0,0,74.32,332.46Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "76.53px 332.46px"
    },
    id: "els3ad7r5itda",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67,332.46a2.21,2.21,0,1,0,2.21-2.21A2.2,2.2,0,0,0,67,332.46Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "69.21px 332.46px"
    },
    id: "elyauzwrizxcj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.75,332.46A2.21,2.21,0,1,0,62,330.25,2.21,2.21,0,0,0,59.75,332.46Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "61.96px 332.46px"
    },
    id: "elu2vn91vofzj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.46,332.46a2.21,2.21,0,1,0,2.21-2.21A2.21,2.21,0,0,0,52.46,332.46Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "54.67px 332.46px"
    },
    id: "elqwkzq3xjtno",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elmiiyxfh2vy"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 88.94,
    y: 316.99,
    width: 1.27,
    height: 17.68,
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "89.575px 325.83px",
      transform: "rotate(180deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el8dwbbk8ptne"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49.03,
    y: 342.38,
    width: 94.29,
    height: 26.4,
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "96.175px 355.58px",
      transform: "rotate(180deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 143.33,
    y: 342.38,
    width: 24.96,
    height: 26.4,
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "155.81px 355.58px"
    },
    id: "elnczixxhiw4c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elv99vaqkr5t"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 93.47,
    y: 346.74,
    width: 45.05,
    height: 2.23,
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "115.995px 347.855px",
      transform: "rotate(180deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elzo3mwtfbb7n"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 93.47,
    y: 350.6,
    width: 45.05,
    height: 2.23,
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "115.995px 351.715px",
      transform: "rotate(180deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el01ysava8wxif"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 93.47,
    y: 354.46,
    width: 45.05,
    height: 2.23,
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "115.995px 355.575px",
      transform: "rotate(180deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ely6vz1adxt6"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 93.47,
    y: 358.33,
    width: 45.05,
    height: 2.23,
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "115.995px 359.445px",
      transform: "rotate(180deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elxezsh3goz8j"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 93.47,
    y: 362.19,
    width: 45.05,
    height: 2.23,
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "115.995px 363.305px",
      transform: "rotate(180deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 83.82,
    cy: 348.95,
    r: 2.21,
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "83.82px 348.95px"
    },
    id: "eli409s4yn59b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.32,349a2.21,2.21,0,1,0,2.21-2.21A2.21,2.21,0,0,0,74.32,349Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "76.53px 349px"
    },
    id: "elke8n98wv07p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67,349a2.21,2.21,0,1,0,2.21-2.21A2.2,2.2,0,0,0,67,349Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "69.21px 349px"
    },
    id: "eljqti5c7lev8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.75,349A2.21,2.21,0,1,0,62,346.74,2.21,2.21,0,0,0,59.75,349Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "61.9594px 348.95px"
    },
    id: "elz34r4up195",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.46,349a2.21,2.21,0,1,0,2.21-2.21A2.21,2.21,0,0,0,52.46,349Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "54.67px 349px"
    },
    id: "elsumax9itx3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.61,355.58a2.21,2.21,0,1,0,2.21-2.21A2.21,2.21,0,0,0,81.61,355.58Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "83.82px 355.58px"
    },
    id: "el7pb85mtsupk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.32,355.58a2.21,2.21,0,1,0,2.21-2.21A2.21,2.21,0,0,0,74.32,355.58Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "76.53px 355.58px"
    },
    id: "eltn5p4lhwara",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67,355.58a2.21,2.21,0,1,0,2.21-2.21A2.2,2.2,0,0,0,67,355.58Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "69.21px 355.58px"
    },
    id: "el47d71vfs7el",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.75,355.58A2.21,2.21,0,1,0,62,353.37,2.21,2.21,0,0,0,59.75,355.58Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "61.96px 355.58px"
    },
    id: "elx80zaluztg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.46,355.58a2.21,2.21,0,1,0,2.21-2.21A2.21,2.21,0,0,0,52.46,355.58Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "54.67px 355.58px"
    },
    id: "eldtngqwk69hl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.61,362.21A2.21,2.21,0,1,0,83.82,360,2.21,2.21,0,0,0,81.61,362.21Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "83.82px 362.21px"
    },
    id: "el16xr2g8rze8j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.32,362.21A2.21,2.21,0,1,0,76.53,360,2.21,2.21,0,0,0,74.32,362.21Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "76.53px 362.21px"
    },
    id: "el13m6zss4lzh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67,362.21A2.21,2.21,0,1,0,69.25,360,2.2,2.2,0,0,0,67,362.21Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "69.21px 362.21px"
    },
    id: "el7hqw556b6lj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.75,362.21A2.21,2.21,0,1,0,62,360,2.21,2.21,0,0,0,59.75,362.21Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "61.96px 362.21px"
    },
    id: "elh9m232rh3an",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.46,362.21A2.21,2.21,0,1,0,54.67,360,2.21,2.21,0,0,0,52.46,362.21Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "54.67px 362.21px"
    },
    id: "elc2qxaxyvktd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "ellohde7twc6"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 88.94,
    y: 346.74,
    width: 1.27,
    height: 17.68,
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "89.575px 355.58px",
      transform: "rotate(180deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ela9ki45swrza"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49.03,
    y: 372.13,
    width: 94.29,
    height: 26.4,
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "96.175px 385.33px",
      transform: "rotate(180deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 143.33,
    y: 372.13,
    width: 24.96,
    height: 26.4,
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "155.81px 385.33px"
    },
    id: "elfu3tgup7npn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elyer12sigofm"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 93.47,
    y: 376.49,
    width: 45.05,
    height: 2.23,
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "115.995px 377.605px",
      transform: "rotate(180deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elkkp0wur8xu"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 93.47,
    y: 380.35,
    width: 45.05,
    height: 2.23,
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "115.995px 381.465px",
      transform: "rotate(180deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el86w64kdbowl"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 93.47,
    y: 384.21,
    width: 45.05,
    height: 2.23,
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "115.995px 385.325px",
      transform: "rotate(180deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "eldak3pqoul6c"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 93.47,
    y: 388.07,
    width: 45.05,
    height: 2.23,
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "115.995px 389.185px",
      transform: "rotate(180deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elhbrksuqwtmp"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 93.47,
    y: 391.94,
    width: 45.05,
    height: 2.23,
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "115.995px 393.055px",
      transform: "rotate(180deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M81.61,378.7a2.21,2.21,0,1,0,2.21-2.21A2.21,2.21,0,0,0,81.61,378.7Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "83.82px 378.7px"
    },
    id: "elojb7vcopn3f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.32,378.7a2.21,2.21,0,1,0,2.21-2.21A2.21,2.21,0,0,0,74.32,378.7Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "76.53px 378.7px"
    },
    id: "elch7rxxqin84",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67,378.7a2.21,2.21,0,1,0,2.21-2.21A2.2,2.2,0,0,0,67,378.7Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "69.21px 378.7px"
    },
    id: "elrkncf74u939",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.75,378.7A2.21,2.21,0,1,0,62,376.49,2.21,2.21,0,0,0,59.75,378.7Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "61.96px 378.7px"
    },
    id: "elplluz0pqpuo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.46,378.7a2.21,2.21,0,1,0,2.21-2.21A2.21,2.21,0,0,0,52.46,378.7Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "54.67px 378.7px"
    },
    id: "eldoefkko9jg5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.61,385.33a2.21,2.21,0,1,0,2.21-2.21A2.21,2.21,0,0,0,81.61,385.33Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "83.82px 385.33px"
    },
    id: "el45zwm3p5rsu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.32,385.33a2.21,2.21,0,1,0,2.21-2.21A2.21,2.21,0,0,0,74.32,385.33Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "76.53px 385.33px"
    },
    id: "elcm2rd68joe7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67,385.33a2.21,2.21,0,1,0,2.21-2.21A2.2,2.2,0,0,0,67,385.33Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "69.21px 385.33px"
    },
    id: "el4jzqe2v4gz6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.75,385.33A2.21,2.21,0,1,0,62,383.12,2.21,2.21,0,0,0,59.75,385.33Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "61.96px 385.33px"
    },
    id: "el7x6upzrd3t",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.46,385.33a2.21,2.21,0,1,0,2.21-2.21A2.21,2.21,0,0,0,52.46,385.33Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "54.67px 385.33px"
    },
    id: "elt58hgru7ams",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.61,392a2.21,2.21,0,1,0,2.21-2.21A2.21,2.21,0,0,0,81.61,392Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "83.82px 392px"
    },
    id: "elw0akr8k2a1i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.32,392a2.21,2.21,0,1,0,2.21-2.21A2.21,2.21,0,0,0,74.32,392Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "76.53px 392px"
    },
    id: "el1b034ttwwjd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67,392a2.21,2.21,0,1,0,2.21-2.21A2.2,2.2,0,0,0,67,392Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "69.21px 392px"
    },
    id: "elojvb13q6g3a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.75,392A2.21,2.21,0,1,0,62,389.75,2.21,2.21,0,0,0,59.75,392Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "61.9596px 391.96px"
    },
    id: "el8wagaok429w",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.46,392a2.21,2.21,0,1,0,2.21-2.21A2.21,2.21,0,0,0,52.46,392Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "54.67px 392px"
    },
    id: "elk8arlk79crk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el3gesl3ubh1j"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 88.94,
    y: 376.49,
    width: 1.27,
    height: 17.68,
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "89.575px 385.33px",
      transform: "rotate(180deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elu7wu2zyzno"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49.03,
    y: 401.87,
    width: 94.29,
    height: 26.4,
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "96.175px 415.07px",
      transform: "rotate(180deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 143.33,
    y: 401.87,
    width: 24.96,
    height: 26.4,
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "155.81px 415.07px"
    },
    id: "elsh0ypp93qe",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elkhtk7cvhrpo"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 93.47,
    y: 406.23,
    width: 45.05,
    height: 2.23,
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "115.995px 407.345px",
      transform: "rotate(180deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el22gi3rqgn07"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 93.47,
    y: 410.1,
    width: 45.05,
    height: 2.23,
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "115.995px 411.215px",
      transform: "rotate(180deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "eltc2bqpdcu6"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 93.47,
    y: 413.96,
    width: 45.05,
    height: 2.23,
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "115.995px 415.075px",
      transform: "rotate(180deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elfzjfmbjsssu"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 93.47,
    y: 417.82,
    width: 45.05,
    height: 2.23,
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "115.995px 418.935px",
      transform: "rotate(180deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "eluj1h6ymsz2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 93.47,
    y: 421.68,
    width: 45.05,
    height: 2.23,
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "115.995px 422.795px",
      transform: "rotate(180deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 83.82,
    cy: 408.44,
    r: 2.21,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "83.82px 408.44px"
    },
    id: "elr7usyqqzte",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.32,408.44a2.21,2.21,0,1,0,2.21-2.21A2.21,2.21,0,0,0,74.32,408.44Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "76.53px 408.44px"
    },
    id: "elkpl2yayhaw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67,408.44a2.21,2.21,0,1,0,2.21-2.21A2.2,2.2,0,0,0,67,408.44Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "69.21px 408.44px"
    },
    id: "elktdxr7imvjj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.75,408.44A2.21,2.21,0,1,0,62,406.23,2.21,2.21,0,0,0,59.75,408.44Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "61.96px 408.44px"
    },
    id: "eloygdu8a8o7q",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.46,408.44a2.21,2.21,0,1,0,2.21-2.21A2.21,2.21,0,0,0,52.46,408.44Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "54.67px 408.44px"
    },
    id: "el4oljg4y60n5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 83.82,
    cy: 415.07,
    r: 2.21,
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "83.82px 415.07px"
    },
    id: "el4qng2qkkywn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.32,415.07a2.21,2.21,0,1,0,2.21-2.21A2.21,2.21,0,0,0,74.32,415.07Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "76.53px 415.07px"
    },
    id: "elju1kdfcn2uf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67,415.07a2.21,2.21,0,1,0,2.21-2.21A2.2,2.2,0,0,0,67,415.07Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "69.21px 415.07px"
    },
    id: "elxhs86idzrhm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.75,415.07A2.21,2.21,0,1,0,62,412.86,2.21,2.21,0,0,0,59.75,415.07Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "61.96px 415.07px"
    },
    id: "el5xf6tl9us3a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.46,415.07a2.21,2.21,0,1,0,2.21-2.21A2.21,2.21,0,0,0,52.46,415.07Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "54.67px 415.07px"
    },
    id: "elf6r0xkaaooe",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.61,421.7a2.21,2.21,0,1,0,2.21-2.21A2.21,2.21,0,0,0,81.61,421.7Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "83.82px 421.7px"
    },
    id: "el9meor7zvzh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.32,421.7a2.21,2.21,0,1,0,2.21-2.21A2.21,2.21,0,0,0,74.32,421.7Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "76.53px 421.7px"
    },
    id: "el72ehvyyphhi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67,421.7a2.21,2.21,0,1,0,2.21-2.21A2.2,2.2,0,0,0,67,421.7Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "69.21px 421.7px"
    },
    id: "elpr1g159vug9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.75,421.7A2.21,2.21,0,1,0,62,419.49,2.21,2.21,0,0,0,59.75,421.7Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "61.96px 421.7px"
    },
    id: "elwbvor2zz0bg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.46,421.7a2.21,2.21,0,1,0,2.21-2.21A2.21,2.21,0,0,0,52.46,421.7Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "54.67px 421.7px"
    },
    id: "elktn4j1jcqpc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "ellqz42x8vqpf"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 88.94,
    y: 406.23,
    width: 1.27,
    height: 17.68,
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "89.575px 415.07px",
      transform: "rotate(180deg)"
    },
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-517",
    className: "animable",
    style: {
      transformOrigin: "375px 281.36px"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 100.11,
    y: 417.23,
    width: 549.78,
    height: 20.02,
    style: {
      fill: "rgb(199, 199, 199)",
      transformOrigin: "375px 427.24px"
    },
    id: "elubhtn053ijj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.92,
    y: 125.47,
    width: 436.16,
    height: 291.76,
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "375px 271.35px"
    },
    id: "elizk4xp74tpg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160.09,
    y: 129.03,
    width: 429.83,
    height: 284.64,
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "375.005px 271.35px"
    },
    id: "el8t75qt4vn2p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 179.12,
    y: 147.32,
    width: 391.76,
    height: 248.05,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "375px 271.345px"
    },
    id: "elsmem29c99ta",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 179.12,
    y: 147.32,
    width: 391.76,
    height: 9.54,
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "375px 152.09px"
    },
    id: "elfqjo22wkbip",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.11,152.1a1.81,1.81,0,1,1-1.81-1.81A1.81,1.81,0,0,1,188.11,152.1Z",
    style: {
      fill: "rgb(199, 199, 199)",
      transformOrigin: "186.3px 152.1px"
    },
    id: "eli7xz8ov4u1",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.48,152.1a1.81,1.81,0,1,1-1.81-1.81A1.81,1.81,0,0,1,195.48,152.1Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "193.67px 152.1px"
    },
    id: "elurs4bduv37",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.86,152.1a1.81,1.81,0,1,1-1.81-1.81A1.81,1.81,0,0,1,202.86,152.1Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "201.05px 152.1px"
    },
    id: "el963jj97xgnc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "233.93 257.37 233.8 247.61 233.76 237.84 233.68 218.32 233.76 198.79 233.8 189.03 233.93 179.26 234.05 189.03 234.09 198.79 234.18 218.32 234.09 237.84 234.05 247.61 233.93 257.37",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "233.93px 218.315px"
    },
    id: "elhhy8zyc8hv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "261.09 257.37 260.97 247.61 260.93 237.84 260.84 218.32 260.92 198.79 260.97 189.03 261.09 179.26 261.21 189.03 261.26 198.79 261.34 218.32 261.26 237.84 261.21 247.61 261.09 257.37",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "261.09px 218.315px"
    },
    id: "elbqhwv26g29d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "288.26 257.37 288.14 247.61 288.09 237.84 288.01 218.32 288.09 198.79 288.13 189.03 288.26 179.26 288.38 189.03 288.43 198.79 288.51 218.32 288.43 237.84 288.38 247.61 288.26 257.37",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "288.26px 218.315px"
    },
    id: "elvcp1u364pmo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "315.42 257.37 315.3 247.61 315.26 237.84 315.17 218.32 315.26 198.79 315.3 189.03 315.42 179.26 315.55 189.03 315.59 198.79 315.68 218.32 315.59 237.84 315.55 247.61 315.42 257.37",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "315.425px 218.315px"
    },
    id: "el3u76q7o2p6e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "342.59 257.37 342.47 247.61 342.42 237.84 342.34 218.32 342.42 198.79 342.47 189.03 342.59 179.26 342.71 189.03 342.76 198.79 342.84 218.32 342.76 237.84 342.71 247.61 342.59 257.37",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "342.59px 218.315px"
    },
    id: "elkvvghygbnno",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "369.76 257.37 369.63 247.61 369.59 237.84 369.5 218.32 369.59 198.79 369.63 189.03 369.76 179.26 369.88 189.03 369.92 198.79 370.01 218.32 369.92 237.84 369.88 247.61 369.76 257.37",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "369.755px 218.315px"
    },
    id: "elqalwq569lvd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "396.92 257.37 396.8 247.61 396.76 237.84 396.67 218.32 396.75 198.79 396.8 189.03 396.92 179.26 397.05 189.03 397.09 198.79 397.17 218.32 397.09 237.84 397.05 247.61 396.92 257.37",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "396.92px 218.315px"
    },
    id: "ely5y5mfvjwqg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "424.09 257.37 423.97 247.61 423.92 237.84 423.84 218.32 423.92 198.79 423.97 189.03 424.09 179.26 424.21 189.03 424.26 198.79 424.34 218.32 424.26 237.84 424.21 247.61 424.09 257.37",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "424.09px 218.315px"
    },
    id: "el94a59kgybs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "451.25 257.37 451.13 247.61 451.09 237.84 451 218.32 451.09 198.79 451.13 189.03 451.25 179.26 451.38 189.03 451.42 198.79 451.51 218.32 451.42 237.84 451.38 247.61 451.25 257.37",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "451.255px 218.315px"
    },
    id: "elwyldy3n2qm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "478.42 257.37 478.3 247.61 478.25 237.84 478.17 218.32 478.25 198.79 478.3 189.03 478.42 179.26 478.55 189.03 478.59 198.79 478.67 218.32 478.59 237.84 478.54 247.61 478.42 257.37",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "478.42px 218.315px"
    },
    id: "elbaiy86j3o75",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "505.59 257.37 505.46 247.61 505.42 237.84 505.34 218.32 505.42 198.79 505.46 189.03 505.59 179.26 505.71 189.03 505.75 198.79 505.84 218.32 505.75 237.84 505.71 247.61 505.59 257.37",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "505.59px 218.315px"
    },
    id: "elp448zcgado",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "532.75 257.37 532.63 247.61 532.59 237.84 532.5 218.32 532.59 198.79 532.63 189.03 532.75 179.26 532.88 189.03 532.92 198.79 533 218.32 532.92 237.84 532.88 247.61 532.75 257.37",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "532.75px 218.315px"
    },
    id: "elikpykhdi4bq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "206.76 179.26 291.51 179.09 376.25 179.01 461 179.09 545.74 179.26 461 179.43 376.25 179.51 291.51 179.43 206.76 179.26",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "376.25px 179.26px"
    },
    id: "elfqq5gx511gl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "206.76 198.19 291.51 198.02 376.25 197.93 461 198.02 545.74 198.19 461 198.35 376.25 198.44 291.51 198.35 206.76 198.19",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "376.25px 198.185px"
    },
    id: "elxtr51or3sp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "206.76 217.11 291.51 216.94 376.25 216.86 461 216.94 545.74 217.11 461 217.28 376.25 217.36 291.51 217.28 206.76 217.11",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "376.25px 217.11px"
    },
    id: "elyy9gx4dnz1h",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "206.76 236.03 291.51 235.86 376.25 235.78 461 235.86 545.74 236.03 461 236.2 376.25 236.28 291.51 236.2 206.76 236.03",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "376.25px 236.03px"
    },
    id: "el8q9beimcqi3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.76,217.11l27.11-9.69h0L261.08,206h.06l.06,0,27.19,10.8-.07,0,27.18,4.83h-.11l27.16-2.4-.18.05c9.05-4.85,18.08-9.73,27.16-14.53l.09-.05h.1l27.17-2.06H397l27.15,5.64H424l27.19-10.35.07,0h.07l27.16,2.89h-.09l27.21-6.65h0l10.12.06-10.12.07h0l-27.12,7h-.08l-27.18-2.75.14,0-27.14,10.47-.1,0-.1,0-27.18-5.52H397l-27.17,2.17.19-.05c-9,4.87-18.11,9.67-27.17,14.49l-.09,0h-.09l-27.17,2.28h-.11l-27.15-4.94h-.07L261,206.51l.12,0-27.18,1.24h0Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "361.245px 208.28px"
    },
    id: "el0igcj1kq4o89",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.19,207.59a2.27,2.27,0,1,1-2.26-2.26A2.27,2.27,0,0,1,236.19,207.59Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "233.92px 207.6px"
    },
    id: "elj6u5yjefsjo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.93,210.36a2.77,2.77,0,1,1,2.76-2.77A2.77,2.77,0,0,1,233.93,210.36Zm0-4.53a1.76,1.76,0,1,0,1.76,1.76A1.76,1.76,0,0,0,233.93,205.83Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "233.92px 207.59px"
    },
    id: "elvfr46jj4dd9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.36,206.31a2.27,2.27,0,1,1-2.27-2.27A2.27,2.27,0,0,1,263.36,206.31Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "261.09px 206.31px"
    },
    id: "elk5kskedj8m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.09,209.08a2.77,2.77,0,1,1,2.77-2.77A2.78,2.78,0,0,1,261.09,209.08Zm0-4.53a1.76,1.76,0,1,0,1.76,1.76A1.76,1.76,0,0,0,261.09,204.55Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "261.09px 206.31px"
    },
    id: "elkgcuaz1kimt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.69,222a2.27,2.27,0,1,1-2.27-2.26A2.27,2.27,0,0,1,317.69,222Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "315.42px 222.01px"
    },
    id: "elppsosn5islr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.42,224.76a2.77,2.77,0,1,1,2.77-2.77A2.77,2.77,0,0,1,315.42,224.76Zm0-4.53a1.76,1.76,0,1,0,1.77,1.76A1.76,1.76,0,0,0,315.42,220.23Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "315.42px 221.99px"
    },
    id: "el3y5pue6jt48",
    className: "animable"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 369.59,
    cy: 205.33,
    r: 2.27,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "369.59px 205.33px"
    },
    id: "elap08jzrq1wm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.59,208.09a2.77,2.77,0,1,1,2.77-2.76A2.77,2.77,0,0,1,369.59,208.09Zm0-4.53a1.77,1.77,0,1,0,1.76,1.77A1.76,1.76,0,0,0,369.59,203.56Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "369.59px 205.32px"
    },
    id: "elsxgknlcd8w",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.35,208.82a2.27,2.27,0,1,1-2.26-2.27A2.26,2.26,0,0,1,426.35,208.82Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "424.08px 208.82px"
    },
    id: "elk2iqc8xtoq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.09,211.59a2.77,2.77,0,1,1,2.77-2.77A2.77,2.77,0,0,1,424.09,211.59Zm0-4.53a1.76,1.76,0,1,0,1.76,1.76A1.76,1.76,0,0,0,424.09,207.06Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "424.09px 208.82px"
    },
    id: "elxvdujsgijh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.86,219.73a2.27,2.27,0,1,1-2.27-2.27A2.27,2.27,0,0,1,344.86,219.73Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "342.59px 219.73px"
    },
    id: "elsq8tq38gzug",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.59,222.5a2.77,2.77,0,1,1,2.77-2.77A2.78,2.78,0,0,1,342.59,222.5Zm0-4.53a1.76,1.76,0,1,0,1.76,1.76A1.76,1.76,0,0,0,342.59,218Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "342.59px 219.73px"
    },
    id: "elp8jqrhf6vk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.19,203.06a2.27,2.27,0,1,1-2.27-2.26A2.27,2.27,0,0,1,399.19,203.06Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "396.92px 203.07px"
    },
    id: "elpkjtcps4jz",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.92,205.83a2.77,2.77,0,1,1,2.77-2.77A2.78,2.78,0,0,1,396.92,205.83Zm0-4.53a1.76,1.76,0,1,0,1.76,1.76A1.76,1.76,0,0,0,396.92,201.3Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "396.92px 203.06px"
    },
    id: "el9z4e6t5f01j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.69,200.8a2.27,2.27,0,1,1-2.27-2.27A2.27,2.27,0,0,1,480.69,200.8Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "478.42px 200.8px"
    },
    id: "el4hsohk7bpv6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.42,203.56a2.77,2.77,0,1,1,2.77-2.76A2.77,2.77,0,0,1,478.42,203.56Zm0-4.53a1.77,1.77,0,1,0,1.76,1.77A1.76,1.76,0,0,0,478.42,199Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "478.42px 200.79px"
    },
    id: "elbb6tlvqxw0n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.85,194.19a2.27,2.27,0,1,1-2.26-2.26A2.27,2.27,0,0,1,507.85,194.19Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "505.58px 194.2px"
    },
    id: "elufdpgu6gcj9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.59,197a2.77,2.77,0,1,1,2.77-2.77A2.77,2.77,0,0,1,505.59,197Zm0-4.53a1.77,1.77,0,1,0,1.76,1.76A1.76,1.76,0,0,0,505.59,192.43Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "505.59px 194.23px"
    },
    id: "elqnpzalgblcg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.52,198.06a2.27,2.27,0,1,1-2.26-2.27A2.26,2.26,0,0,1,453.52,198.06Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "451.25px 198.06px"
    },
    id: "elxwisl63r3w",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.25,200.82a2.77,2.77,0,1,1,2.77-2.76A2.77,2.77,0,0,1,451.25,200.82Zm0-4.53a1.77,1.77,0,1,0,1.77,1.77A1.76,1.76,0,0,0,451.25,196.29Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "451.25px 198.05px"
    },
    id: "elgybck0adya",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.52,217.11a2.27,2.27,0,1,1-2.26-2.27A2.26,2.26,0,0,1,290.52,217.11Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "288.25px 217.11px"
    },
    id: "el41hfz454ch7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.26,219.88a2.77,2.77,0,1,1,2.77-2.77A2.78,2.78,0,0,1,288.26,219.88Zm0-4.53a1.76,1.76,0,1,0,1.76,1.76A1.76,1.76,0,0,0,288.26,215.35Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "288.26px 217.11px"
    },
    id: "el61sqto1ckos",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.76,236.14l27.14-3.52-.07,0,27.1-18.71,0,0h0l27.15-10.19.11,0,.12,0,27.18,9.1h.05l0,0,27.19,16.87-.41,0c9.05-3.6,18.09-7.22,27.16-10.77l.2-.07.19.09,27.14,13.47-.51.11,27.21-32,.17-.2.24.09,27.14,10.23-.14,0,27.17-3.3h0l27.16,1.4h0l10.14-3.43-10.1,3.55h0l-27.17-1.06h0l-27.16,3.44h-.07l-.07,0L424,201.14l.41-.11-27.12,32-.22.25-.3-.14-27.19-13.37h.39c-9,3.62-18.11,7.16-27.17,10.73l-.22.08-.19-.12-27.14-17,.09,0-27.15-9.21h.23l-27.19,10.07.06,0L234,232.94l0,0h0Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "361.175px 218.23px"
    },
    id: "el8dg5n8yjya",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.19,232.79a2.27,2.27,0,1,1-2.26-2.26A2.26,2.26,0,0,1,236.19,232.79Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "233.92px 232.8px"
    },
    id: "elgdsl73bb1l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.93,235.56a2.77,2.77,0,1,1,2.76-2.76A2.77,2.77,0,0,1,233.93,235.56Zm0-4.53a1.77,1.77,0,1,0,1.76,1.77A1.77,1.77,0,0,0,233.93,231Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "233.92px 232.79px"
    },
    id: "elmipu1afniqc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.36,214.18a2.27,2.27,0,1,1-2.27-2.27A2.27,2.27,0,0,1,263.36,214.18Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "261.09px 214.18px"
    },
    id: "el7q6memgg21m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.09,216.94a2.77,2.77,0,1,1,2.77-2.76A2.77,2.77,0,0,1,261.09,216.94Zm0-4.53a1.77,1.77,0,1,0,1.76,1.77A1.76,1.76,0,0,0,261.09,212.41Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "261.09px 214.17px"
    },
    id: "elfum62cm7v89",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.69,213.37a2.27,2.27,0,1,1-2.27-2.27A2.26,2.26,0,0,1,317.69,213.37Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "315.42px 213.37px"
    },
    id: "elgwhi391z1e5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.42,216.14a2.77,2.77,0,1,1,2.77-2.77A2.77,2.77,0,0,1,315.42,216.14Zm0-4.53a1.76,1.76,0,1,0,1.77,1.76A1.76,1.76,0,0,0,315.42,211.61Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "315.42px 213.37px"
    },
    id: "elrw7cjcp03jr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.85,219.73a2.27,2.27,0,1,1-2.26-2.27A2.26,2.26,0,0,1,371.85,219.73Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "369.58px 219.73px"
    },
    id: "el570suaoosv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.59,222.5a2.77,2.77,0,1,1,2.77-2.77A2.78,2.78,0,0,1,369.59,222.5Zm0-4.53a1.76,1.76,0,1,0,1.76,1.76A1.76,1.76,0,0,0,369.59,218Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "369.59px 219.73px"
    },
    id: "elyywsem5umd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.35,200.8a2.27,2.27,0,1,1-2.26-2.27A2.26,2.26,0,0,1,426.35,200.8Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "424.08px 200.8px"
    },
    id: "elsnunwlgsajo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.09,203.56a2.77,2.77,0,1,1,2.77-2.76A2.77,2.77,0,0,1,424.09,203.56Zm0-4.53a1.77,1.77,0,1,0,1.76,1.77A1.76,1.76,0,0,0,424.09,199Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "424.09px 200.79px"
    },
    id: "eljbfbgvco3z",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.86,229.78a2.27,2.27,0,1,1-2.27-2.26A2.27,2.27,0,0,1,344.86,229.78Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "342.59px 229.79px"
    },
    id: "elriyz15kwcdb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.59,232.55a2.77,2.77,0,1,1,2.77-2.77A2.77,2.77,0,0,1,342.59,232.55Zm0-4.53a1.76,1.76,0,1,0,1.76,1.76A1.76,1.76,0,0,0,342.59,228Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "342.59px 229.78px"
    },
    id: "ele0cz9qe56mc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.19,232.38a2.27,2.27,0,1,1-2.27-2.26A2.27,2.27,0,0,1,399.19,232.38Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "396.92px 232.39px"
    },
    id: "ellznpu5c1o2q",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.92,235.15a2.77,2.77,0,1,1,2.77-2.77A2.78,2.78,0,0,1,396.92,235.15Zm0-4.53a1.77,1.77,0,1,0,1.76,1.76A1.76,1.76,0,0,0,396.92,230.62Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "396.92px 232.38px"
    },
    id: "elwjf7iqvn2vh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.69,207.6a2.27,2.27,0,1,1-2.27-2.26A2.27,2.27,0,0,1,480.69,207.6Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "478.42px 207.61px"
    },
    id: "elovcfplnii7b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.42,210.37a2.77,2.77,0,1,1,2.77-2.77A2.78,2.78,0,0,1,478.42,210.37Zm0-4.53a1.77,1.77,0,1,0,1.76,1.76A1.76,1.76,0,0,0,478.42,205.84Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "478.42px 207.6px"
    },
    id: "elvhj6f8uwew",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.85,208.82a2.27,2.27,0,1,1-2.26-2.27A2.26,2.26,0,0,1,507.85,208.82Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "505.58px 208.82px"
    },
    id: "elq8g7ao8bpdb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.59,211.59a2.77,2.77,0,1,1,2.77-2.77A2.77,2.77,0,0,1,505.59,211.59Zm0-4.53a1.76,1.76,0,1,0,1.76,1.76A1.76,1.76,0,0,0,505.59,207.06Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "505.59px 208.82px"
    },
    id: "elwzff7khh07",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.52,211.08a2.27,2.27,0,1,1-2.26-2.26A2.27,2.27,0,0,1,453.52,211.08Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "451.25px 211.09px"
    },
    id: "el19twntk2a94",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.25,213.85a2.77,2.77,0,1,1,2.77-2.77A2.77,2.77,0,0,1,451.25,213.85Zm0-4.53a1.77,1.77,0,1,0,1.77,1.76A1.76,1.76,0,0,0,451.25,209.32Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "451.25px 211.08px"
    },
    id: "eloizky7ajpoh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.52,204a2.27,2.27,0,1,1-2.26-2.26A2.27,2.27,0,0,1,290.52,204Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "288.25px 204.01px"
    },
    id: "elsb3kqdbd5ms",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.26,206.81A2.77,2.77,0,1,1,291,204,2.77,2.77,0,0,1,288.26,206.81Zm0-4.53A1.76,1.76,0,1,0,290,204,1.76,1.76,0,0,0,288.26,202.28Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "288.23px 204.04px"
    },
    id: "elzakb55dijvi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.76,175.24l.19,38.94.1,38.93-.29-.3,84.75-.13,42.37-.07,42.37.06,84.75.14c28.25,0,56.5.17,84.74.3-28.24.13-56.49.29-84.74.3l-84.75.14-42.37.06-42.37-.07-84.75-.14h-.3v-.29l.11-38.93Z",
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "376.1px 214.425px"
    },
    id: "elpjbki3v4aa",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.26,179.26a5.85,5.85,0,0,1,2.5-.5,5.73,5.73,0,0,1,2.5.5,6.5,6.5,0,0,1-5,0Z",
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "206.76px 179.259px"
    },
    id: "elb79cgfsis17",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.26,198.18a6.5,6.5,0,0,1,5,0,6.38,6.38,0,0,1-5,0Z",
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "206.76px 198.185px"
    },
    id: "elgi39pm1yaau",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.26,217.11a6.38,6.38,0,0,1,5,0,5.73,5.73,0,0,1-2.5.5A5.85,5.85,0,0,1,204.26,217.11Z",
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "206.76px 217.106px"
    },
    id: "el6fsl8krtzla",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.26,236a6.5,6.5,0,0,1,5,0,6.5,6.5,0,0,1-5,0Z",
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "206.76px 236px"
    },
    id: "elplmcy27hv3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.24,261.14a.06.06,0,0,1,.09,0,.57.57,0,0,0,1.12-.17v-1.33a.07.07,0,1,1,.14,0V261a.72.72,0,0,1-1.4.22A.07.07,0,0,1,227.24,261.14Z",
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "227.889px 260.637px"
    },
    id: "elewrk6zweyz",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.25,261.18h-1l-.19.5a.08.08,0,0,1-.07.05h0a.08.08,0,0,1-.05-.09l.74-2a.08.08,0,0,1,.14,0l.74,2a.07.07,0,0,1,0,.09h0a.09.09,0,0,1-.07-.05Zm-.92-.15h.86l-.43-1.14Z",
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "229.757px 260.664px"
    },
    id: "elznogf05qwzi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.19,259.92v1.73a.07.07,0,1,1-.14,0v-1.94a.08.08,0,0,1,0-.08s.09,0,.11,0l1.28,1.78V259.7a.07.07,0,0,1,.07-.07.07.07,0,0,1,.08.07v1.95a.08.08,0,0,1-.08.08.05.05,0,0,1-.05,0h0Z",
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "231.815px 260.683px"
    },
    id: "elejpjb4hj2yv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.22,259.68a.07.07,0,0,1,.07-.07.08.08,0,0,1,.08.07v1.19a.71.71,0,1,0,1.41,0v-1.19a.08.08,0,0,1,.08-.07.07.07,0,0,1,.07.07v1.19a.86.86,0,1,1-1.71,0Z",
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "234.075px 260.716px"
    },
    id: "elakl6oigt5n4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.68,261.18h-1l-.19.5a.08.08,0,0,1-.07.05h0a.08.08,0,0,1,0-.09l.74-2a.08.08,0,0,1,.14,0l.74,2a.07.07,0,0,1,0,.09h0a.08.08,0,0,1-.07-.05Zm-.91-.15h.86l-.43-1.14Z",
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "236.231px 260.664px"
    },
    id: "ele05q7f00s74",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.53,261.25a.38.38,0,0,0-.17-.32.78.78,0,0,0-.25-.11h-.53v.84a.08.08,0,0,1-.07.08.09.09,0,0,1-.08-.08v-2a.07.07,0,0,1,.07-.07h.61a.6.6,0,0,1,.6.6.61.61,0,0,1-.35.55h0a.55.55,0,0,1,.29.48,1.1,1.1,0,0,0,0,.24.07.07,0,0,0,0,.05.08.08,0,0,1,.08,0,.08.08,0,0,1,0,.1h-.05a.16.16,0,0,1-.13-.09A.7.7,0,0,1,238.53,261.25Zm-.42-1.5h-.53v.92h.54a.46.46,0,0,0,.44-.46A.46.46,0,0,0,238.11,259.75Z",
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "238.089px 260.665px"
    },
    id: "el841531cjpd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.87,260.71l-.71-1s0-.09,0-.11.09,0,.11,0l.66.91.67-.91a.07.07,0,0,1,.1,0,.08.08,0,0,1,0,.11l-.7,1v.95a.08.08,0,0,1-.08.08.08.08,0,0,1-.07-.08Z",
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "239.941px 260.66px"
    },
    id: "elce4gihlrpj5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.9,259.68a.07.07,0,0,1,.07-.07h1.09a.07.07,0,0,1,0,.14h-1v.84h.89a.08.08,0,0,1,.07.08.07.07,0,0,1-.07.07h-.89v.91a.09.09,0,0,1-.08.08.08.08,0,0,1-.07-.08Z",
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "254.515px 260.67px"
    },
    id: "eloac4sx9tu9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.72,259.68a.08.08,0,0,1,.08-.07h1.09a.07.07,0,0,1,0,.14h-1v.84h.89a.08.08,0,0,1,.07.08.07.07,0,0,1-.07.07h-.89v.84h1a.07.07,0,0,1,.07.07.08.08,0,0,1-.07.08h-1.1a.1.1,0,0,1-.07-.08Z",
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "256.34px 260.67px"
    },
    id: "elc1rn6cwnfpp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.52,259.68a.07.07,0,0,1,.07-.07h.47a.53.53,0,0,1,.53.53.54.54,0,0,1-.2.41.61.61,0,0,1-.2,1.18h-.6a.08.08,0,0,1-.07-.08Zm.54.83a.38.38,0,0,0,.38-.37.38.38,0,0,0-.38-.39h-.4v.76Zm.13,1.07a.46.46,0,0,0,0-.92h-.53v.92Z",
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "258.152px 260.67px"
    },
    id: "elkjuh4zib1wm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.36,261.25a.36.36,0,0,0-.17-.32.67.67,0,0,0-.24-.11h-.53v.84a.09.09,0,0,1-.08.08.08.08,0,0,1-.07-.08v-2a.07.07,0,0,1,.07-.07h.6a.6.6,0,0,1,.6.6.62.62,0,0,1-.34.55h0a.57.57,0,0,1,.28.48.62.62,0,0,0,0,.24s0,.05,0,.05a.09.09,0,0,1,.08,0,.09.09,0,0,1,0,.1h0a.19.19,0,0,1-.14-.09A.84.84,0,0,1,260.36,261.25Zm-.42-1.5h-.52v.92H260a.46.46,0,0,0,0-.92Z",
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "259.923px 260.665px"
    },
    id: "elmh4usylb6u",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261,259.68a.07.07,0,0,1,.07-.07.07.07,0,0,1,.08.07v1.19a.71.71,0,1,0,1.42,0v-1.19a.07.07,0,0,1,.14,0v1.19a.86.86,0,1,1-1.71,0Z",
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "261.855px 260.716px"
    },
    id: "elc77vou7psg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.49,261.18h-1l-.19.5a.08.08,0,0,1-.07.05h0a.08.08,0,0,1-.05-.09l.74-2a.07.07,0,0,1,.07,0s.07,0,.07,0l.74,2a.06.06,0,0,1,0,.09h0a.1.1,0,0,1-.07-.05Zm-.92-.15h.86l-.43-1.14Z",
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "263.999px 260.68px"
    },
    id: "elvsf82hkdd2f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.33,261.25a.38.38,0,0,0-.17-.32.7.7,0,0,0-.25-.11h-.53v.84a.07.07,0,1,1-.14,0v-2a.07.07,0,0,1,.06-.07h.61a.6.6,0,0,1,.6.6.61.61,0,0,1-.35.55h0a.55.55,0,0,1,.29.48,1.1,1.1,0,0,0,0,.24l0,.05a.11.11,0,0,1,.09,0,.09.09,0,0,1-.05.1h0a.17.17,0,0,1-.14-.09A.7.7,0,0,1,266.33,261.25Zm-.42-1.5h-.53v.92h.54a.46.46,0,0,0,0-.92Z",
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "265.891px 260.66px"
    },
    id: "el9uhcqv0y18o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.67,260.71l-.71-1a.09.09,0,0,1,0-.11.07.07,0,0,1,.1,0l.66.91.67-.91a.07.07,0,0,1,.1,0,.09.09,0,0,1,0,.11l-.71,1v.95a.08.08,0,0,1-.07.08.09.09,0,0,1-.08-.08Z",
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "267.725px 260.659px"
    },
    id: "elrt9sgpdx94p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.87,259.91l-.67.94-.06,0h0a.06.06,0,0,1-.06,0l-.68-.94v1.74a.09.09,0,0,1-.07.08.08.08,0,0,1-.08-.08v-2a.09.09,0,0,1,0-.06h0a.07.07,0,0,1,.1,0l.75,1,.75-1s.07,0,.11,0l0,0s0,0,0,0v2a.08.08,0,0,1-.07.08.08.08,0,0,1-.08-.08Z",
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "284.102px 260.649px"
    },
    id: "elc0eitnyb46l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.75,261.18h-1l-.19.5a.08.08,0,0,1-.07.05h0a.08.08,0,0,1,0-.09l.74-2a.08.08,0,0,1,.14,0l.74,2a.08.08,0,0,1,0,.09h0a.08.08,0,0,1-.07-.05Zm-.91-.15h.86l-.43-1.14Z",
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "286.3px 260.664px"
    },
    id: "elswtbnsnywze",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.6,261.25a.38.38,0,0,0-.17-.32.78.78,0,0,0-.25-.11h-.53v.84a.08.08,0,0,1-.07.08.09.09,0,0,1-.08-.08v-2a.07.07,0,0,1,.07-.07h.61a.6.6,0,0,1,.6.6.61.61,0,0,1-.35.55h0a.54.54,0,0,1,.28.48.93.93,0,0,0,0,.24.07.07,0,0,0,0,.05.08.08,0,0,1,.08,0,.1.1,0,0,1,0,.1h0a.16.16,0,0,1-.13-.09A.7.7,0,0,1,288.6,261.25Zm-.42-1.5h-.53v.92h.54a.46.46,0,0,0,.44-.46A.46.46,0,0,0,288.18,259.75Z",
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "288.152px 260.665px"
    },
    id: "eltrjxkurxfj9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.44,259.58a1.17,1.17,0,0,1,.69.23.08.08,0,0,1,0,.11.08.08,0,0,1-.1,0,1,1,0,0,0-.6-.21.93.93,0,1,0,0,1.86.92.92,0,0,0,.59-.21.08.08,0,0,1,.1.13,1.17,1.17,0,0,1-.69.23,1.08,1.08,0,1,1,0-2.15Z",
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "290.199px 260.645px"
    },
    id: "elvi8cqk6ptgf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293,260.74h-1.09v.91a.08.08,0,0,1-.07.08.09.09,0,0,1-.08-.08v-2a.08.08,0,0,1,.08-.07.07.07,0,0,1,.07.07v.91H293v-.91a.08.08,0,0,1,.07-.07.07.07,0,0,1,.08.07v2a.08.08,0,0,1-.08.08.09.09,0,0,1-.07-.08Z",
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "292.455px 260.655px"
    },
    id: "el3bnh4klwemc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.79,261.18h-1l-.19.5a.08.08,0,0,1-.07.05h0a.08.08,0,0,1-.05-.09l.74-2a.07.07,0,0,1,.07,0s.07,0,.07,0l.74,2a.06.06,0,0,1,0,.09h0a.1.1,0,0,1-.07-.05Zm-.91-.15h.85l-.42-1.14Z",
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "312.299px 260.68px"
    },
    id: "elm46yauxmau",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.58,259.68a.07.07,0,0,1,.07-.07h.6a.6.6,0,0,1,0,1.2h-.52v.83a.09.09,0,0,1-.08.08.08.08,0,0,1-.07-.08Zm.67,1a.46.46,0,0,0,0-.92h-.52v.92Z",
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "314.215px 260.665px"
    },
    id: "elhqw22q18w1",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.39,261.25a.36.36,0,0,0-.17-.32.67.67,0,0,0-.24-.11h-.53v.84a.09.09,0,0,1-.08.08.08.08,0,0,1-.07-.08v-2a.07.07,0,0,1,.06-.07H316a.6.6,0,0,1,.6.6.61.61,0,0,1-.35.55h0a.55.55,0,0,1,.29.48.62.62,0,0,0,0,.24s0,.05,0,.05a.09.09,0,0,1,.08,0,.09.09,0,0,1-.05.1h0a.17.17,0,0,1-.14-.09A.84.84,0,0,1,316.39,261.25Zm-.42-1.5h-.52v.92H316a.46.46,0,0,0,0-.92Z",
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "315.961px 260.665px"
    },
    id: "eleusemhrqg8m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.25,259.68a.07.07,0,0,1,.07-.07.08.08,0,0,1,.08.07v2a.09.09,0,0,1-.08.08.08.08,0,0,1-.07-.08Z",
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "317.325px 260.685px"
    },
    id: "el1yivphz1art",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.23,261.73h0a.08.08,0,0,1-.07-.08v-2a.07.07,0,0,1,.07-.07.07.07,0,0,1,.08.07v1.9h1a.07.07,0,0,1,.08.07.08.08,0,0,1-.08.08Z",
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "318.775px 260.655px"
    },
    id: "eldc7dz43wosq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.59,259.91l-.68.94-.06,0h0l-.06,0-.68-.94v1.74a.08.08,0,0,1-.07.08.09.09,0,0,1-.08-.08v-2s0,0,0-.06h0a.07.07,0,0,1,.1,0l.76,1,.75-1a.07.07,0,0,1,.1,0l0,0a.06.06,0,0,1,0,0v2a.07.07,0,1,1-.14,0Z",
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "340.815px 260.649px"
    },
    id: "elibdt03qn3lb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.47,261.18h-1l-.19.5a.08.08,0,0,1-.07.05h0a.08.08,0,0,1-.05-.09l.74-2a.07.07,0,0,1,.07,0s.07,0,.07,0l.74,2a.06.06,0,0,1,0,.09h0a.1.1,0,0,1-.07-.05Zm-.91-.15h.85l-.43-1.14Z",
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "342.979px 260.68px"
    },
    id: "el1zdsi9s6n4f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.61,260.71l-.71-1a.09.09,0,0,1,0-.11.07.07,0,0,1,.1,0l.66.91.67-.91a.07.07,0,0,1,.1,0s0,.07,0,.11l-.71,1v.95a.08.08,0,0,1-.07.08.09.09,0,0,1-.08-.08Z",
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "344.656px 260.659px"
    },
    id: "elbn77xj8qsp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.88,261.14a.06.06,0,0,1,.09,0,.57.57,0,0,0,.54.4.58.58,0,0,0,.58-.57v-1.33a.07.07,0,1,1,.14,0V261a.72.72,0,0,1-1.4.22A.07.07,0,0,1,365.88,261.14Z",
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "366.529px 260.637px"
    },
    id: "el86xd6l9ty8q",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.8,259.68a.08.08,0,0,1,.07-.07.07.07,0,0,1,.08.07v1.19a.71.71,0,0,0,1.42,0v-1.19a.07.07,0,0,1,.07-.07.08.08,0,0,1,.08.07v1.19a.86.86,0,0,1-1.72,0Z",
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "368.66px 260.67px"
    },
    id: "el1f6vay3kx1sh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.37,259.92v1.73a.08.08,0,1,1-.15,0v-1.94a.07.07,0,0,1,0-.08.07.07,0,0,1,.1,0l1.29,1.78V259.7a.07.07,0,0,1,.14,0v1.95a.08.08,0,0,1-.07.08.07.07,0,0,1-.06,0h0Z",
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "370.979px 260.683px"
    },
    id: "elr9bhes1xvg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.35,259.68a.07.07,0,0,1,.07-.07h1.09a.07.07,0,0,1,0,.14h-1v.84h.89a.08.08,0,0,1,.07.08.07.07,0,0,1-.07.07h-.89v.84h1a.07.07,0,0,1,.07.07.08.08,0,0,1-.07.08h-1.1a.09.09,0,0,1-.06-.08Z",
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "372.965px 260.67px"
    },
    id: "el0r74pu0ie8il",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.49,261.14a.06.06,0,0,1,.09,0,.57.57,0,0,0,1.11-.17v-1.33a.08.08,0,0,1,.08-.07.07.07,0,0,1,.07.07V261a.72.72,0,0,1-1.4.22A.07.07,0,0,1,393.49,261.14Z",
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "394.139px 260.637px"
    },
    id: "elh0zsdn8w35",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.41,259.68a.07.07,0,0,1,.07-.07.07.07,0,0,1,.08.07v1.19a.71.71,0,1,0,1.42,0v-1.19a.07.07,0,0,1,.07-.07.08.08,0,0,1,.08.07v1.19a.86.86,0,1,1-1.72,0Z",
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "396.27px 260.67px"
    },
    id: "elkrdv27lxmj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.81,261.73h0a.08.08,0,0,1-.07-.08v-2a.07.07,0,0,1,.07-.07.08.08,0,0,1,.08.07v1.9h1a.08.08,0,0,1,.08.07.09.09,0,0,1-.08.08Z",
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "398.355px 260.655px"
    },
    id: "elh9pphn3moa",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.62,260.71l-.71-1a.08.08,0,0,1,0-.11.07.07,0,0,1,.1,0l.67.91.66-.91s.07,0,.11,0a.08.08,0,0,1,0,.11l-.71,1v.95a.07.07,0,1,1-.14,0Z",
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "399.68px 260.654px"
    },
    id: "elk0r10t6gcol",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419,261.18h-1l-.19.5a.08.08,0,0,1-.07.05h0s-.06-.06,0-.09l.73-2a.09.09,0,0,1,.08,0,.07.07,0,0,1,.07,0l.74,2a.08.08,0,0,1,0,.09h0a.08.08,0,0,1-.07-.05Zm-.91-.15h.86l-.43-1.14Z",
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "418.544px 260.68px"
    },
    id: "el1ydxvqzyqcn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.69,259.68a.07.07,0,0,1,.07-.07.07.07,0,0,1,.08.07v1.19a.71.71,0,1,0,1.42,0v-1.19a.07.07,0,0,1,.07-.07.08.08,0,0,1,.08.07v1.19a.86.86,0,1,1-1.72,0Z",
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "420.55px 260.67px"
    },
    id: "elpytkp8ylrdb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.14,260.77a.08.08,0,0,1-.08-.07.09.09,0,0,1,.08-.08h.66a.08.08,0,0,1,.07.08v.73h0a.05.05,0,0,1,0,.05,1.08,1.08,0,0,1-.68.24,1.08,1.08,0,1,1,0-2.15,1.08,1.08,0,0,1,.68.24.07.07,0,0,1,0,.1.08.08,0,0,1-.1,0,.94.94,0,1,0-.59,1.65,1,1,0,0,0,.56-.18v-.63Z",
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "422.949px 260.645px"
    },
    id: "elgq7ltlls1ef",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.61,259.68a.07.07,0,0,1,.07-.07.07.07,0,0,1,.08.07v1.19a.71.71,0,1,0,1.42,0v-1.19a.07.07,0,1,1,.14,0v1.19a.86.86,0,1,1-1.71,0Z",
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "425.465px 260.716px"
    },
    id: "elyc565gxe8km",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427,261.33a.06.06,0,0,1,.09,0,1.11,1.11,0,0,0,.7.27.77.77,0,0,0,.47-.14.39.39,0,0,0,.18-.31.35.35,0,0,0-.17-.29,1.23,1.23,0,0,0-.49-.17h0a1.54,1.54,0,0,1-.5-.18.46.46,0,0,1-.22-.37.51.51,0,0,1,.22-.4.85.85,0,0,1,.51-.15,1.19,1.19,0,0,1,.66.24.08.08,0,0,1,0,.1.06.06,0,0,1-.09,0,1.06,1.06,0,0,0-.59-.22.73.73,0,0,0-.43.13.38.38,0,0,0-.16.29.3.3,0,0,0,.15.25,1.08,1.08,0,0,0,.46.16h0a1.38,1.38,0,0,1,.54.2.47.47,0,0,1,.23.4.52.52,0,0,1-.23.42.92.92,0,0,1-.55.17,1.32,1.32,0,0,1-.78-.31A.06.06,0,0,1,427,261.33Z",
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "427.77px 260.66px"
    },
    id: "elix3bkpjzof",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.59,259.75H429a.07.07,0,1,1,0-.14h1.42a.07.07,0,0,1,0,.14h-.64v1.9a.07.07,0,1,1-.14,0Z",
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "429.71px 260.665px"
    },
    id: "eli7xzlofa4ys",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.77,261.33a.08.08,0,0,1,.1,0,1.08,1.08,0,0,0,.69.27.77.77,0,0,0,.47-.14.37.37,0,0,0,.18-.31.35.35,0,0,0-.17-.29,1.23,1.23,0,0,0-.49-.17h0a1.54,1.54,0,0,1-.5-.18.46.46,0,0,1-.22-.37.51.51,0,0,1,.22-.4.89.89,0,0,1,.52-.15,1.18,1.18,0,0,1,.65.24.08.08,0,0,1,0,.1.06.06,0,0,1-.09,0,1.06,1.06,0,0,0-.58-.22.74.74,0,0,0-.44.13.38.38,0,0,0-.16.29.3.3,0,0,0,.15.25,1.08,1.08,0,0,0,.46.16h0a1.32,1.32,0,0,1,.54.2.48.48,0,0,1,.24.4.53.53,0,0,1-.24.42.92.92,0,0,1-.55.17,1.32,1.32,0,0,1-.78-.31A.06.06,0,0,1,442.77,261.33Z",
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "443.545px 260.66px"
    },
    id: "el3z8mmamyro",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.88,259.68a.08.08,0,0,1,.08-.07h1.09a.07.07,0,0,1,0,.14h-1v.84h.89a.08.08,0,0,1,.07.08.07.07,0,0,1-.07.07H445v.84h1a.07.07,0,0,1,.07.07.08.08,0,0,1-.07.08H445a.08.08,0,0,1-.07-.08Z",
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "445.5px 260.67px"
    },
    id: "elb28vjjstdj6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.68,259.68a.07.07,0,0,1,.07-.07h.6a.6.6,0,0,1,0,1.2h-.53v.83a.07.07,0,1,1-.14,0Zm.67,1a.46.46,0,0,0,0-.92h-.53v.92Z",
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "447.315px 260.66px"
    },
    id: "elmaik0p0dflp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449,259.75h-.64a.07.07,0,1,1,0-.14h1.42a.07.07,0,0,1,0,.14h-.64v1.9a.07.07,0,1,1-.14,0Z",
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "449.07px 260.665px"
    },
    id: "el132h2qw6x1rb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.4,259.68a.07.07,0,0,1,.07-.07h1.09a.07.07,0,0,1,0,.14h-1v.84h.89a.08.08,0,0,1,.07.08.07.07,0,0,1-.07.07h-.89v.84h1a.07.07,0,0,1,.07.07.08.08,0,0,1-.07.08h-1.1a.09.09,0,0,1-.06-.08Z",
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "451.015px 260.67px"
    },
    id: "elldws78p5dx",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.82,259.91l-.68.94a.07.07,0,0,1-.06,0h0a.09.09,0,0,1-.07,0l-.67-.94v1.74a.09.09,0,0,1-.08.08.08.08,0,0,1-.07-.08v-2a.09.09,0,0,1,0-.06h0a.08.08,0,0,1,.11,0l.75,1,.75-1a.07.07,0,0,1,.1,0l0,0s0,0,0,0v2a.09.09,0,0,1-.08.08.08.08,0,0,1-.07-.08Z",
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "453.042px 260.649px"
    },
    id: "elx2iub9i2zcn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.74,259.68a.07.07,0,0,1,.07-.07h.47a.53.53,0,0,1,.53.53.54.54,0,0,1-.2.41.61.61,0,0,1-.19,1.18h-.61a.08.08,0,0,1-.07-.08Zm.54.83a.38.38,0,0,0,.38-.37.38.38,0,0,0-.38-.39h-.39v.76Zm.14,1.07a.46.46,0,0,0,0-.92h-.53v.92Z",
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "455.372px 260.67px"
    },
    id: "elasb8gfjhapj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.53,259.68a.08.08,0,0,1,.07-.07h1.09a.07.07,0,1,1,0,.14h-1v.84h.89a.08.08,0,0,1,.07.08.07.07,0,0,1-.07.07h-.89v.84h1a.07.07,0,0,1,.08.07.08.08,0,0,1-.08.08H456.6a.08.08,0,0,1-.07-.08Z",
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "457.15px 260.67px"
    },
    id: "elibo53722d6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.44,261.25a.37.37,0,0,0-.18-.32.67.67,0,0,0-.24-.11h-.53v.84a.08.08,0,0,1-.08.08.08.08,0,0,1-.07-.08v-2a.07.07,0,0,1,.07-.07h.6a.6.6,0,0,1,.61.6.63.63,0,0,1-.35.55h0a.54.54,0,0,1,.28.48.93.93,0,0,0,0,.24.07.07,0,0,0,0,.05.09.09,0,0,1,.08,0,.09.09,0,0,1-.05.1h0a.16.16,0,0,1-.13-.09A.7.7,0,0,1,459.44,261.25Zm-.43-1.5h-.52v.92H459a.46.46,0,0,0,0-.92Z",
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "458.986px 260.665px"
    },
    id: "elro7plowhv79",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.37,259.58a1.08,1.08,0,0,1,0,2.15,1.08,1.08,0,0,1,0-2.15Zm0,2a.9.9,0,0,0,.86-.93.87.87,0,1,0-1.74,0A.91.91,0,0,0,472.37,261.58Z",
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "472.37px 260.655px"
    },
    id: "el7mrv4sgxrwi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.92,259.58a1.17,1.17,0,0,1,.69.23.08.08,0,0,1,0,.11.08.08,0,0,1-.1,0,1,1,0,0,0-.6-.21.93.93,0,1,0,0,1.86.92.92,0,0,0,.59-.21s.09,0,.11,0a.08.08,0,0,1,0,.11,1.17,1.17,0,0,1-.69.23,1.08,1.08,0,1,1,0-2.15Z",
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "474.684px 260.625px"
    },
    id: "elhq003c0your",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.79,259.75h-.64a.07.07,0,0,1,0-.14h1.43a.07.07,0,0,1,0,.14h-.64v1.9a.08.08,0,0,1-.07.08.09.09,0,0,1-.08-.08Z",
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "476.865px 260.67px"
    },
    id: "elr9yogyrgbnj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479,259.58a1.08,1.08,0,0,1,0,2.15,1.08,1.08,0,0,1,0-2.15Zm0,2a.9.9,0,0,0,.86-.93.87.87,0,1,0-.86.93Z",
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "479px 260.655px"
    },
    id: "el1kaetjvu5cy",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.5,259.68a.07.07,0,0,1,.07-.07H481a.53.53,0,0,1,.53.53.54.54,0,0,1-.2.41.59.59,0,0,1,.41.57.6.6,0,0,1-.6.61h-.61a.08.08,0,0,1-.07-.08Zm.54.83a.38.38,0,0,0,.38-.37.38.38,0,0,0-.38-.39h-.39v.76Zm.14,1.07a.46.46,0,0,0,0-.92h-.53v.92Z",
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "481.1px 260.67px"
    },
    id: "el7p9qovxzgsr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.29,259.68a.08.08,0,0,1,.08-.07h1.09a.07.07,0,0,1,0,.14h-1v.84h.89a.08.08,0,0,1,.07.08.07.07,0,0,1-.07.07h-.89v.84h1a.07.07,0,0,1,.07.07.08.08,0,0,1-.07.08h-1.1a.08.08,0,0,1-.07-.08Z",
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "482.91px 260.67px"
    },
    id: "eluv414gu8wkg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.2,261.25a.38.38,0,0,0-.17-.32.78.78,0,0,0-.25-.11h-.53v.84a.08.08,0,0,1-.07.08.09.09,0,0,1-.08-.08v-2a.07.07,0,0,1,.07-.07h.61a.6.6,0,0,1,.6.6.61.61,0,0,1-.35.55h0a.55.55,0,0,1,.29.48,1.1,1.1,0,0,0,0,.24.07.07,0,0,0,0,.05.08.08,0,0,1,.08,0,.1.1,0,0,1,0,.1h-.05a.16.16,0,0,1-.13-.09A.7.7,0,0,1,485.2,261.25Zm-.42-1.5h-.53v.92h.54a.46.46,0,0,0,.44-.46A.46.46,0,0,0,484.78,259.75Z",
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "484.757px 260.665px"
    },
    id: "el4vxkbsc1p5o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.72,259.92v1.73a.08.08,0,1,1-.15,0v-1.94a.07.07,0,0,1,0-.08.07.07,0,0,1,.1,0l1.29,1.78V259.7a.07.07,0,0,1,.14,0v1.95a.08.08,0,0,1-.07.08.07.07,0,0,1-.06,0h0Z",
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "498.329px 260.683px"
    },
    id: "elhem41i46dif",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.67,259.58a1.08,1.08,0,1,1-1,1.07A1,1,0,0,1,500.67,259.58Zm0,2a.9.9,0,0,0,.86-.93.87.87,0,1,0-1.73,0A.9.9,0,0,0,500.67,261.58Z",
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "500.749px 260.657px"
    },
    id: "elucfryjl3sf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.89,261.68h0l-.82-1.95a.08.08,0,0,1,0-.1.09.09,0,0,1,.1,0l.75,1.81.76-1.81s.06-.05.1,0a.1.1,0,0,1,0,.1l-.83,1.94a.05.05,0,0,1,0,.06h-.06S502.89,261.7,502.89,261.68Z",
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "502.923px 260.669px"
    },
    id: "eld8ahlio5zcu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.36,259.68a.08.08,0,0,1,.08-.07h1.09a.07.07,0,1,1,0,.14h-1v.84h.89a.08.08,0,0,1,.07.08.07.07,0,0,1-.07.07h-.89v.84h1a.07.07,0,0,1,.07.07.08.08,0,0,1-.07.08h-1.1a.08.08,0,0,1-.07-.08Z",
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "504.98px 260.67px"
    },
    id: "el182kbkdx07q",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.79,259.91l-.68.94a.07.07,0,0,1-.06,0h0a.09.09,0,0,1-.07,0l-.68-.94v1.74a.07.07,0,1,1-.14,0v-2a.09.09,0,0,1,0-.06h0s.08,0,.1,0l.76,1,.75-1a.07.07,0,0,1,.1,0l0,0,0,0v2a.09.09,0,0,1-.08.08.08.08,0,0,1-.07-.08Z",
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "507.012px 260.644px"
    },
    id: "el3fr1yanj1az",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.71,259.68a.07.07,0,0,1,.07-.07h.47a.53.53,0,0,1,.53.53.54.54,0,0,1-.2.41.61.61,0,0,1-.2,1.18h-.6a.08.08,0,0,1-.07-.08Zm.54.83a.38.38,0,0,0,.38-.37.38.38,0,0,0-.38-.39h-.39v.76Zm.13,1.07a.46.46,0,0,0,0-.92h-.52v.92Z",
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "509.342px 260.67px"
    },
    id: "el5q0pdzvfr1v",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.5,259.68a.08.08,0,0,1,.07-.07h1.09a.07.07,0,1,1,0,.14h-1v.84h.89a.08.08,0,0,1,.07.08.07.07,0,0,1-.07.07h-.89v.84h1a.07.07,0,0,1,.08.07.08.08,0,0,1-.08.08h-1.09a.08.08,0,0,1-.07-.08Z",
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "511.12px 260.67px"
    },
    id: "elewsiijlq3h8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.41,261.25a.38.38,0,0,0-.17-.32.78.78,0,0,0-.25-.11h-.53v.84a.08.08,0,0,1-.08.08.08.08,0,0,1-.07-.08v-2a.07.07,0,0,1,.07-.07h.6a.6.6,0,0,1,.61.6.63.63,0,0,1-.35.55h0a.54.54,0,0,1,.28.48.62.62,0,0,0,0,.24.07.07,0,0,0,0,.05.09.09,0,0,1,.08,0,.09.09,0,0,1-.05.1h0a.16.16,0,0,1-.13-.09A.7.7,0,0,1,513.41,261.25Zm-.43-1.5h-.52v.92H513a.46.46,0,0,0,0-.92Z",
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "512.956px 260.665px"
    },
    id: "el2gdv26c6r8f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.14,261.73h0a.08.08,0,0,1-.07-.08v-2a.07.07,0,0,1,.07-.07h.4a1.06,1.06,0,1,1,0,2.12Zm.39-.15a.92.92,0,0,0,0-1.83h-.32v1.83Z",
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "525.837px 260.655px"
    },
    id: "el38z9h66o5qk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.08,259.68a.07.07,0,0,1,.07-.07h1.09a.07.07,0,1,1,0,.14h-1v.84h.89a.09.09,0,0,1,.07.08.08.08,0,0,1-.07.07h-.89v.84h1a.08.08,0,0,1,.08.07.09.09,0,0,1-.08.08h-1.09a.08.08,0,0,1-.07-.08Z",
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "527.7px 260.67px"
    },
    id: "elpea1d7tmyfm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.88,259.58a1.11,1.11,0,0,1,.68.23.08.08,0,0,1,0,.11.09.09,0,0,1-.11,0,.93.93,0,1,0,0,1.44.07.07,0,0,1,.1,0,.07.07,0,0,1,0,.11,1.11,1.11,0,0,1-.68.23,1.08,1.08,0,1,1,0-2.15Z",
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "529.634px 260.625px"
    },
    id: "elkdtpw6ecpl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.2,259.68a.07.07,0,0,1,.07-.07h1.09a.07.07,0,1,1,0,.14h-1v.84h.89a.08.08,0,0,1,.07.08.07.07,0,0,1-.07.07h-.89v.84h1a.07.07,0,0,1,.08.07.08.08,0,0,1-.08.08h-1.09a.08.08,0,0,1-.07-.08Z",
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "531.82px 260.67px"
    },
    id: "elte4nhm4fajs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.63,259.91l-.68.94-.06,0h0a.07.07,0,0,1-.06,0l-.68-.94v1.74a.08.08,0,0,1-.07.08.09.09,0,0,1-.08-.08v-2a.09.09,0,0,1,0-.06h0a.07.07,0,0,1,.1,0l.76,1,.75-1a.07.07,0,0,1,.1,0l0,0a.06.06,0,0,1,0,0v2a.07.07,0,1,1-.14,0Z",
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "533.852px 260.649px"
    },
    id: "el06d7curjennf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.54,259.68a.08.08,0,0,1,.08-.07h.47a.53.53,0,0,1,.53.53.55.55,0,0,1-.21.41.6.6,0,0,1,.42.57.61.61,0,0,1-.61.61h-.61a.08.08,0,0,1-.07-.08Zm.55.83a.38.38,0,0,0,.38-.37.38.38,0,0,0-.38-.39h-.4v.76Zm.13,1.07a.46.46,0,0,0,0-.92h-.53v.92Z",
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "536.185px 260.67px"
    },
    id: "ely10l2fc3jph",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.34,259.68a.07.07,0,0,1,.07-.07h1.09a.07.07,0,1,1,0,.14h-1v.84h.88a.09.09,0,0,1,.08.08.08.08,0,0,1-.08.07h-.88v.84h1a.07.07,0,0,1,.07.07.08.08,0,0,1-.07.08h-1.1a.09.09,0,0,1-.06-.08Z",
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "537.955px 260.67px"
    },
    id: "elqi72u3taee",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540.24,261.25a.36.36,0,0,0-.17-.32.75.75,0,0,0-.24-.11h-.53v.84a.09.09,0,0,1-.08.08.08.08,0,0,1-.07-.08v-2a.07.07,0,0,1,.06-.07h.61a.6.6,0,0,1,.6.6.61.61,0,0,1-.35.55h0a.55.55,0,0,1,.29.48.62.62,0,0,0,0,.24s0,.05,0,.05a.09.09,0,0,1,.08,0,.09.09,0,0,1,0,.1h0a.17.17,0,0,1-.14-.09A.7.7,0,0,1,540.24,261.25Zm-.42-1.5h-.52v.92h.53a.46.46,0,0,0,0-.92Z",
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "539.803px 260.665px"
    },
    id: "elx3l5b2l8lmn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.76,
    y: 274.48,
    width: 52.07,
    height: 24.54,
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "232.795px 286.75px"
    },
    id: "ellffosi1kjl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.76,
    y: 274.48,
    width: 24.96,
    height: 24.54,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "219.24px 286.75px"
    },
    id: "el1nrs2bcbnhg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.08,286.75a8.83,8.83,0,1,1-1.17-4.4A8.84,8.84,0,0,1,228.08,286.75Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "219.25px 286.742px"
    },
    id: "elv1e5zjxwzes",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.91,282.35l-7.67,4.4v-8.84A8.85,8.85,0,0,1,226.91,282.35Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "223.075px 282.33px"
    },
    id: "eldqtamjgffo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.35,286.75a6.11,6.11,0,1,1-6.11-6.11A6.11,6.11,0,0,1,225.35,286.75Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "219.24px 286.75px"
    },
    id: "elfef9dok38d7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.09,286l-.3.18h0a.07.07,0,0,1-.06,0,.08.08,0,0,1,0-.1l.41-.24a.08.08,0,0,1,.1,0,.13.13,0,0,1,0,.06v1.94a.07.07,0,1,1-.14,0Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "216.978px 286.866px"
    },
    id: "elyjt8idjfrq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.8,287.7a.08.08,0,0,1,.11-.11.56.56,0,0,0,.4.17.58.58,0,0,0,.4-.17.57.57,0,0,0,.16-.4.55.55,0,0,0-.16-.4.56.56,0,0,0-.8,0,.08.08,0,0,1-.11,0l0,0h0v0l.1-.85a.09.09,0,0,1,0-.05.06.06,0,0,1,.05,0h1a.07.07,0,0,1,.07.07.07.07,0,0,1-.07.08H218l-.08.63a.75.75,0,0,1,.36-.1.71.71,0,0,1,.51.21.7.7,0,0,1,.2.51.72.72,0,0,1-.2.51.77.77,0,0,1-.51.21A.71.71,0,0,1,217.8,287.7Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "218.404px 286.947px"
    },
    id: "eli6oddo7bc4d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.58,286.31h0a.51.51,0,0,1,.47-.55.5.5,0,0,1,.46.54h0a.5.5,0,0,1-.47.54A.51.51,0,0,1,219.58,286.31Zm.78,0h0a.38.38,0,0,0-.32-.42c-.17,0-.3.19-.3.41h0c0,.23.14.41.31.41S220.36,286.54,220.36,286.31Zm-.49,1.51,1.47-2,.06,0s.07,0,.07.06,0,0,0,0l-1.48,2a.06.06,0,0,1-.06,0,.06.06,0,0,1-.06-.06S219.86,287.83,219.87,287.82Zm.94-.42h0a.5.5,0,0,1,.47-.54.49.49,0,0,1,.46.53h0a.47.47,0,1,1-.93,0Zm.78,0h0a.37.37,0,0,0-.32-.41c-.17,0-.3.18-.3.4h0c0,.24.14.41.31.41S221.59,287.62,221.59,287.4Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "220.662px 286.844px"
    },
    id: "elel43dztvt3u",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224.88,
    y: 280.34,
    width: 9.94,
    height: 0.5,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "229.85px 280.59px"
    },
    id: "ely0110jx8s0f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.88,280.59a1.06,1.06,0,1,1-1.06-1.06A1.06,1.06,0,0,1,235.88,280.59Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "234.82px 280.59px"
    },
    id: "el03xbgeoh2slx",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.41,279.66a2.67,2.67,0,0,1,.17,1.64,3.53,3.53,0,0,1-.75,1.65,1.9,1.9,0,0,1-1.41.76,1.25,1.25,0,0,1-1.14-.76,2.69,2.69,0,0,1-.17-1.65,3.54,3.54,0,0,1,.75-1.64,1.91,1.91,0,0,1,1.41-.76A1.26,1.26,0,0,1,241.41,279.66Zm-.59,1.64a2,2,0,0,0-.12-1.22.64.64,0,0,0-.56-.42,1,1,0,0,0-.73.42,2.74,2.74,0,0,0-.54,1.22,2,2,0,0,0,.12,1.22.64.64,0,0,0,.56.43,1,1,0,0,0,.72-.43A2.65,2.65,0,0,0,240.82,281.3Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "239.845px 281.305px"
    },
    id: "el48dqbruqs8v",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.36,279.26s0,0,0,0l-.71,4.05a.47.47,0,0,1-.45.38.31.31,0,0,1-.31-.38l.6-3.39-.3.17a.54.54,0,0,1-.21.05.3.3,0,0,1-.29-.18.43.43,0,0,1,.22-.52l.94-.5,0,0h0l0,0h.25l0,0,0,0,0,0,0,0s0,0,0,0l0,0h0a0,0,0,0,0,0,0v.15Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "243.514px 281.315px"
    },
    id: "el88x2n5bsmyu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.55,
    y: 285.81,
    width: 15.29,
    height: 0.78,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "245.195px 286.2px"
    },
    id: "el3mgd4xt6wgf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.55,
    y: 287.76,
    width: 12.78,
    height: 0.78,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "243.94px 288.15px"
    },
    id: "elhd1g3vqz9c5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.55,
    y: 289.7,
    width: 17.92,
    height: 0.78,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "246.51px 290.09px"
    },
    id: "elsjmt1w641hr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.55,
    y: 291.64,
    width: 7.65,
    height: 0.78,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "241.375px 292.03px"
    },
    id: "ele3qujx9f0a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.55,
    y: 293.59,
    width: 15.29,
    height: 0.78,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "245.195px 293.98px"
    },
    id: "elbn9luni1mgm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 270.54,
    y: 274.48,
    width: 52.07,
    height: 24.54,
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "296.575px 286.75px"
    },
    id: "eli6pyyv5if8r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 270.54,
    y: 274.48,
    width: 24.96,
    height: 24.54,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "283.02px 286.75px"
    },
    id: "elid50vbasvjf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.86,286.75a7.84,7.84,0,0,1-.1,1.29,8.75,8.75,0,1,1,.1-1.29Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "283.11px 286.721px"
    },
    id: "elspf0xrm91qs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.86,286.75a7.84,7.84,0,0,1-.1,1.29L283,286.75v-8.84a8.83,8.83,0,0,1,8.84,8.84Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "287.43px 282.975px"
    },
    id: "elzh4lr53yjv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.13,286.75a6.11,6.11,0,1,1-6.11-6.11A6.11,6.11,0,0,1,289.13,286.75Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "283.02px 286.75px"
    },
    id: "el60hfv1jt0kr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.13,287.78l1-.9a.54.54,0,0,0-.36-.94.54.54,0,0,0-.37.14l-.1.09a.07.07,0,0,1-.1,0,.08.08,0,0,1,0-.11l.1-.09a.69.69,0,0,1,.47-.18.68.68,0,0,1,.51.22.71.71,0,0,1,.18.47.66.66,0,0,1-.23.51l-.84.77h1a.07.07,0,0,1,.07.07.08.08,0,0,1-.07.08h-1.19l-.06,0A.08.08,0,0,1,280.13,287.78Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "280.781px 286.85px"
    },
    id: "elof0p6mam8e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282,287.7a.08.08,0,0,1,0-.11.07.07,0,0,1,.1,0,.6.6,0,0,0,.4.17.56.56,0,0,0,.4-.17.54.54,0,0,0,.17-.4.55.55,0,0,0-.16-.4.58.58,0,0,0-.4-.17.6.6,0,0,0-.41.17.07.07,0,0,1-.1,0l0,0h0s0,0,0,0v0l.1-.85a.05.05,0,0,1,0-.05s0,0,.05,0h1a.07.07,0,0,1,.07.07.07.07,0,0,1-.07.08h-.93l-.07.63a.75.75,0,0,1,.36-.1.7.7,0,0,1,.5.21.67.67,0,0,1,.21.51.69.69,0,0,1-.21.51.75.75,0,0,1-.51.21A.69.69,0,0,1,282,287.7Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "282.599px 286.95px"
    },
    id: "eljk65x07m4m8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.75,286.31h0a.51.51,0,0,1,.47-.55.5.5,0,0,1,.46.54h0a.51.51,0,0,1-.47.54A.5.5,0,0,1,283.75,286.31Zm.77,0h0c0-.24-.14-.42-.31-.42s-.3.19-.3.41h0c0,.23.14.41.31.41S284.52,286.54,284.52,286.31Zm-.48,1.51,1.47-2a.07.07,0,0,1,.06,0,.06.06,0,0,1,.06.06.06.06,0,0,1,0,0l-1.47,2a.09.09,0,0,1-.06,0,.07.07,0,0,1-.07-.06A.05.05,0,0,1,284,287.82Zm.94-.42h0a.5.5,0,0,1,.47-.54.49.49,0,0,1,.46.53h0a.51.51,0,0,1-.47.54A.49.49,0,0,1,285,287.4Zm.77,0h0c0-.24-.14-.41-.31-.41s-.31.18-.31.4h0a.37.37,0,0,0,.32.41C285.62,287.8,285.75,287.62,285.75,287.4Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "284.83px 286.845px"
    },
    id: "elg80nxyrvn5i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288.66,
    y: 280.34,
    width: 9.94,
    height: 0.5,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "293.63px 280.59px"
    },
    id: "eld663mx1tabr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.66,280.59a1.06,1.06,0,1,1-1.06-1.06A1.06,1.06,0,0,1,299.66,280.59Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "298.6px 280.59px"
    },
    id: "elq2v3hcz6em",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.19,279.66a2.67,2.67,0,0,1,.17,1.64,3.53,3.53,0,0,1-.75,1.65,1.9,1.9,0,0,1-1.41.76,1.26,1.26,0,0,1-1.14-.76,2.69,2.69,0,0,1-.17-1.65,3.54,3.54,0,0,1,.75-1.64,1.91,1.91,0,0,1,1.41-.76A1.25,1.25,0,0,1,305.19,279.66Zm-.59,1.64a2,2,0,0,0-.12-1.22.64.64,0,0,0-.56-.42,1,1,0,0,0-.72.42,2.75,2.75,0,0,0-.55,1.22,2,2,0,0,0,.12,1.22.64.64,0,0,0,.56.43,1,1,0,0,0,.73-.43A2.64,2.64,0,0,0,304.6,281.3Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "303.625px 281.305px"
    },
    id: "elpwk7mguv7d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.72,283.34a.51.51,0,0,1-.45.38h-2.45a.32.32,0,0,1-.26-.13.41.41,0,0,1,.12-.54l2.36-1.83a1.11,1.11,0,0,0,.4-.66.78.78,0,0,0-.12-.6.76.76,0,0,0-.61-.29,1.09,1.09,0,0,0-.64.23l-.24.19a.38.38,0,0,1-.54,0,.42.42,0,0,1,.12-.54l.25-.19a2,2,0,0,1,1.18-.42,1.36,1.36,0,0,1,1.13.54,1.44,1.44,0,0,1,.23,1.11,2,2,0,0,1-.75,1.22L307.94,283h1.46A.32.32,0,0,1,309.72,283.34Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "308.367px 281.33px"
    },
    id: "elv6iadhb394",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 301.33,
    y: 285.81,
    width: 14.74,
    height: 0.78,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "308.7px 286.2px"
    },
    id: "ele8vioo5ubm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 301.33,
    y: 287.76,
    width: 8.47,
    height: 0.78,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "305.565px 288.15px"
    },
    id: "el4pjkqw03hiy",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 301.33,
    y: 289.7,
    width: 13.66,
    height: 0.78,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "308.16px 290.09px"
    },
    id: "elpq0u6mt0f5k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 301.33,
    y: 291.64,
    width: 17.92,
    height: 0.78,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "310.29px 292.03px"
    },
    id: "elbkyh1gy26r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 301.33,
    y: 293.59,
    width: 10.39,
    height: 0.78,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "306.525px 293.98px"
    },
    id: "el4veg7kagsky",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 334.32,
    y: 274.48,
    width: 52.07,
    height: 24.54,
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "360.355px 286.75px"
    },
    id: "ely4a8pxefsh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 334.32,
    y: 274.48,
    width: 24.96,
    height: 24.54,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "346.8px 286.75px"
    },
    id: "elt5yse1lvxu7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.64,286.75a8.83,8.83,0,1,1-1.17-4.4A8.83,8.83,0,0,1,355.64,286.75Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "346.81px 286.742px"
    },
    id: "el4ho456pb5ex",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.64,286.75A8.83,8.83,0,0,1,350,295l-3.17-8.25v-8.84a8.83,8.83,0,0,1,8.84,8.84Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "351.25px 286.455px"
    },
    id: "elbh1m2606l6n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.91,286.75a6.11,6.11,0,1,1-6.11-6.11A6.11,6.11,0,0,1,352.91,286.75Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "346.8px 286.75px"
    },
    id: "el3hm5a6r9ry1",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345,287.47h-1.2a.07.07,0,0,1,0-.11l1.23-1.52h0a.08.08,0,0,1,.1,0l0,0h0v1.46h.14a.07.07,0,1,1,0,.14h-.14v.36a.08.08,0,0,1-.08.08.08.08,0,0,1-.07-.08Zm0-.14v-1.25l-1,1.25Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "344.557px 286.851px"
    },
    id: "elztlosis8z5r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.86,287.7a.08.08,0,0,1,.11-.11.56.56,0,0,0,.4.17.6.6,0,0,0,.4-.17.57.57,0,0,0,.16-.4.55.55,0,0,0-.16-.4.56.56,0,0,0-.8,0,.08.08,0,0,1-.11,0s0,0,0,0h0v0l.1-.85a.09.09,0,0,1,0-.05.06.06,0,0,1,0,0h1a.07.07,0,0,1,.07.07.07.07,0,0,1-.07.08h-.92l-.08.63a.75.75,0,0,1,.36-.1.73.73,0,0,1,.51.21.7.7,0,0,1,.2.51.72.72,0,0,1-.2.51.77.77,0,0,1-.51.21A.71.71,0,0,1,345.86,287.7Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "346.439px 286.95px"
    },
    id: "eledn4ybbpx57",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.64,286.31h0a.51.51,0,0,1,.47-.55.5.5,0,0,1,.46.54h0a.5.5,0,0,1-.47.54A.51.51,0,0,1,347.64,286.31Zm.78,0h0a.38.38,0,0,0-.32-.42c-.17,0-.3.19-.3.41h0c0,.23.14.41.31.41S348.42,286.54,348.42,286.31Zm-.49,1.51,1.47-2,.06,0s.07,0,.07.06a.08.08,0,0,1,0,0l-1.47,2a.06.06,0,0,1-.06,0,.06.06,0,0,1-.06-.06S347.92,287.83,347.93,287.82Zm.94-.42h0a.5.5,0,0,1,.47-.54.49.49,0,0,1,.46.53h0a.51.51,0,0,1-.47.54A.49.49,0,0,1,348.87,287.4Zm.78,0h0a.37.37,0,0,0-.32-.41c-.18,0-.3.18-.3.4h0c0,.24.14.41.31.41S349.65,287.62,349.65,287.4Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "348.72px 286.845px"
    },
    id: "elzt8zt9qs4f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.44,
    y: 280.34,
    width: 9.94,
    height: 0.5,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "357.41px 280.59px"
    },
    id: "elkxdz9b7oyve",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.44,280.59a1.06,1.06,0,1,1-1.06-1.06A1.05,1.05,0,0,1,363.44,280.59Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "362.38px 280.59px"
    },
    id: "elvm1kmaevdzn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369,279.66a2.67,2.67,0,0,1,.17,1.64,3.53,3.53,0,0,1-.75,1.65,1.9,1.9,0,0,1-1.41.76,1.26,1.26,0,0,1-1.14-.76,2.69,2.69,0,0,1-.17-1.65,3.54,3.54,0,0,1,.75-1.64,1.91,1.91,0,0,1,1.41-.76A1.25,1.25,0,0,1,369,279.66Zm-.58,1.64a2.05,2.05,0,0,0-.13-1.22.64.64,0,0,0-.56-.42,1,1,0,0,0-.72.42,2.75,2.75,0,0,0-.55,1.22,2.12,2.12,0,0,0,.12,1.22.65.65,0,0,0,.56.43,1,1,0,0,0,.73-.43A2.76,2.76,0,0,0,368.39,281.3Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "367.435px 281.305px"
    },
    id: "eljzws3xhjy8l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.38,280.79a1.5,1.5,0,0,1,.29,1.2,2.11,2.11,0,0,1-.72,1.21,2,2,0,0,1-1.29.5,1.42,1.42,0,0,1-1.12-.5.4.4,0,0,1,.1-.55.39.39,0,0,1,.55,0,.74.74,0,0,0,.6.27,1.13,1.13,0,0,0,.71-.27,1.19,1.19,0,0,0,.39-.66.79.79,0,0,0-.16-.65.78.78,0,0,0-.6-.28.29.29,0,0,1-.27-.12h0a.42.42,0,0,1,.09-.55l.83-.71h-1.11a.31.31,0,0,1-.32-.39.48.48,0,0,1,.46-.39h2a.31.31,0,0,1,.31.39.36.36,0,0,1-.07.18l-.09.1-1,.89A1.44,1.44,0,0,1,373.38,280.79Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "372.301px 281.3px"
    },
    id: "elp4k8lgwdwm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365.12,
    y: 285.81,
    width: 14.08,
    height: 0.78,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "372.16px 286.2px"
    },
    id: "el5i2v5rny3uq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365.12,
    y: 287.76,
    width: 17.92,
    height: 0.78,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "374.08px 288.15px"
    },
    id: "elnaotz2pap4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365.12,
    y: 289.7,
    width: 10.76,
    height: 0.78,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "370.5px 290.09px"
    },
    id: "eldon4vyh0imi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365.12,
    y: 291.64,
    width: 15.65,
    height: 0.78,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "372.945px 292.03px"
    },
    id: "el349g9flcxdp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365.12,
    y: 293.59,
    width: 6.32,
    height: 0.78,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "368.28px 293.98px"
    },
    id: "el1x7ang8q2nf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 398.1,
    y: 274.48,
    width: 52.07,
    height: 24.54,
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "424.135px 286.75px"
    },
    id: "el1p88bg97gox",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 398.1,
    y: 274.48,
    width: 24.96,
    height: 24.54,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "410.58px 286.75px"
    },
    id: "eljy8irylrwx",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.42,286.75a8.83,8.83,0,1,1-1.17-4.4A8.78,8.78,0,0,1,419.42,286.75Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "410.59px 286.742px"
    },
    id: "elu6lrsez0h6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.42,286.75a8.84,8.84,0,0,1-14.57,6.72l5.73-6.72v-8.84a8.83,8.83,0,0,1,8.84,8.84Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "412.135px 286.744px"
    },
    id: "elyemagn0ne1l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.69,286.75a6.11,6.11,0,1,1-6.11-6.11A6.11,6.11,0,0,1,416.69,286.75Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "410.58px 286.75px"
    },
    id: "elpnfmxca2k9a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.72,287.7a.08.08,0,1,1,.11-.11.58.58,0,0,0,.4.17.56.56,0,0,0,.4-.17.58.58,0,0,0,.17-.4.58.58,0,0,0-.57-.57.58.58,0,0,0-.4.17.07.07,0,0,1-.1,0l0,0h0v0l.11-.85a.05.05,0,0,1,0-.05s0,0,.05,0h1a.07.07,0,0,1,.08.07.07.07,0,0,1-.08.08H408l-.08.63a.78.78,0,0,1,.36-.1.72.72,0,0,1,.72.72.73.73,0,0,1-.21.51.77.77,0,0,1-.51.21A.73.73,0,0,1,407.72,287.7Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "408.341px 286.95px"
    },
    id: "elucxb9yep5ym",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.55,287.7a.08.08,0,0,1,.11-.11.56.56,0,0,0,.4.17.58.58,0,0,0,.4-.17.57.57,0,0,0,.16-.4.55.55,0,0,0-.16-.4.56.56,0,0,0-.8,0,.08.08,0,0,1-.11,0s0,0,0,0h0v0l.11-.85a.05.05,0,0,1,0-.05,0,0,0,0,1,0,0h1a.08.08,0,0,1,.08.07.08.08,0,0,1-.08.08h-.92l-.08.63a.78.78,0,0,1,.36-.1.72.72,0,0,1,.72.72.73.73,0,0,1-.21.51.77.77,0,0,1-.51.21A.71.71,0,0,1,409.55,287.7Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "410.139px 286.95px"
    },
    id: "elp9wgskh7wms",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.33,286.31h0a.48.48,0,1,1,.94,0h0a.47.47,0,1,1-.94,0Zm.78,0h0c0-.24-.14-.42-.31-.42s-.31.19-.31.41h0c0,.23.14.41.31.41S412.11,286.54,412.11,286.31Zm-.49,1.51,1.48-2a.05.05,0,0,1,0,0s.07,0,.07.06a.06.06,0,0,1,0,0l-1.48,2a.06.06,0,0,1-.06,0,.06.06,0,0,1-.06-.06S411.61,287.83,411.62,287.82Zm.94-.42h0a.5.5,0,0,1,.47-.54.49.49,0,0,1,.46.53h0a.47.47,0,1,1-.93,0Zm.78,0h0A.37.37,0,0,0,413,287c-.18,0-.31.18-.31.4h0c0,.24.14.41.31.41S413.34,287.62,413.34,287.4Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "412.408px 286.83px"
    },
    id: "elg3gdtn0hjzp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.23,
    y: 280.34,
    width: 9.94,
    height: 0.5,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "421.2px 280.59px"
    },
    id: "elp30t9i6tdp9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.22,280.59a1.06,1.06,0,1,1-1.06-1.06A1.05,1.05,0,0,1,427.22,280.59Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "426.16px 280.59px"
    },
    id: "el7kebkakxuuf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.75,279.66a2.67,2.67,0,0,1,.17,1.64,3.53,3.53,0,0,1-.75,1.65,1.89,1.89,0,0,1-1.4.76,1.24,1.24,0,0,1-1.14-.76,2.69,2.69,0,0,1-.18-1.65,3.54,3.54,0,0,1,.75-1.64,1.91,1.91,0,0,1,1.41-.76A1.24,1.24,0,0,1,432.75,279.66Zm-.58,1.64a2.05,2.05,0,0,0-.13-1.22.64.64,0,0,0-.56-.42,1,1,0,0,0-.72.42,2.63,2.63,0,0,0-.54,1.22,2,2,0,0,0,.11,1.22.65.65,0,0,0,.57.43,1,1,0,0,0,.72-.43A2.76,2.76,0,0,0,432.17,281.3Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "431.186px 281.305px"
    },
    id: "eluq0tz8i38l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.9,282.44a.48.48,0,0,1-.45.38h-.07l-.09.52a.47.47,0,0,1-.44.38.32.32,0,0,1-.32-.38l.1-.52h-2.17a.27.27,0,0,1-.22-.09.37.37,0,0,1,0-.53l3.09-3.15h0l0,0,0,0,0,0h0l0,0h.29l0,0s0,0,0,0h0l0,0,0,0,0,0a.08.08,0,0,0,0,0s0,0,0,0v.12h0l-.49,2.78h.07A.31.31,0,0,1,437.9,282.44Zm-1.14-.38.3-1.7-1.67,1.7Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "436.052px 281.385px"
    },
    id: "elwb6h9eqz7dd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 428.9,
    y: 285.81,
    width: 11.51,
    height: 0.78,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "434.655px 286.2px"
    },
    id: "elp7pjxo7wa98",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 428.9,
    y: 287.76,
    width: 17.92,
    height: 0.78,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "437.86px 288.15px"
    },
    id: "elej43aeks1eo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 428.9,
    y: 289.7,
    width: 8.16,
    height: 0.78,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "432.98px 290.09px"
    },
    id: "ellqefx3jiiyd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 428.9,
    y: 291.64,
    width: 14.64,
    height: 0.78,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "436.22px 292.03px"
    },
    id: "elqzjedlgdqsl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 428.9,
    y: 293.59,
    width: 12.96,
    height: 0.78,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "435.38px 293.98px"
    },
    id: "elpjs4s7tjf9f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 461.88,
    y: 273.98,
    width: 83.86,
    height: 25.04,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "503.81px 286.5px"
    },
    id: "el18uzdjez3m8j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 466.34,
    y: 277.14,
    width: 74.95,
    height: 2.16,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "503.815px 278.22px"
    },
    id: "el8t60bc2r57k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 466.34,
    y: 277.14,
    width: 38.32,
    height: 2.16,
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "485.5px 278.22px"
    },
    id: "elatypx2h2rp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 466.34,
    y: 281.28,
    width: 74.95,
    height: 2.16,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "503.815px 282.36px"
    },
    id: "elyo7q96dnqkl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 466.34,
    y: 281.28,
    width: 68.75,
    height: 2.16,
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "500.715px 282.36px"
    },
    id: "elfu9wy2oe06v",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 466.34,
    y: 285.42,
    width: 74.95,
    height: 2.16,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "503.815px 286.5px"
    },
    id: "elmtt9amzgb8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 466.34,
    y: 285.42,
    width: 22.18,
    height: 2.16,
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "477.43px 286.5px"
    },
    id: "elz11nc9ljs3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 466.34,
    y: 289.56,
    width: 74.95,
    height: 2.16,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "503.815px 290.64px"
    },
    id: "elvuwtf26x5ok",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 466.34,
    y: 289.56,
    width: 58.9,
    height: 2.16,
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "495.79px 290.64px"
    },
    id: "el5erljle0l5a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 466.34,
    y: 293.69,
    width: 74.95,
    height: 2.16,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "503.815px 294.77px"
    },
    id: "el6chlkkgw4xe",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 466.34,
    y: 293.69,
    width: 43.31,
    height: 2.16,
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "487.995px 294.77px"
    },
    id: "elywf24rqz8s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.76,
    y: 311.11,
    width: 115.85,
    height: 68.05,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "264.685px 345.135px"
    },
    id: "elehyrwtgvu2j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217,367.93l47.67-.12c15.9,0,31.79,0,47.68.12-15.89.11-31.78.08-47.68.13Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "264.675px 367.935px"
    },
    id: "elmmy9orx8amh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217,373.22l47.67-.12c15.9,0,31.79,0,47.68.12-15.89.11-31.78.08-47.68.13Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "264.675px 373.225px"
    },
    id: "el2cyccinaz9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217,361.85l47.67-.12c15.9,0,31.79,0,47.68.12-15.89.11-31.78.08-47.68.12Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "264.675px 361.85px"
    },
    id: "el5fwr31jkum7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217,355.77l47.67-.13c15.9.05,31.79,0,47.68.13-15.89.11-31.78.08-47.68.12Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "264.675px 355.765px"
    },
    id: "eltqytucttwu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217,349.69l47.67-.13c15.9.05,31.79,0,47.68.13-15.89.1-31.78.08-47.68.12Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "264.675px 349.685px"
    },
    id: "el0r8fsp1o7v3n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217,343.6l47.67-.12c15.9,0,31.79,0,47.68.12-15.89.11-31.78.09-47.68.13Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "264.675px 343.605px"
    },
    id: "ely2t336xugl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217,337.52l47.67-.12c15.9,0,31.79,0,47.68.12-15.89.11-31.78.08-47.68.13Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "264.675px 337.525px"
    },
    id: "elwkywdit9w3d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217,331.44l47.67-.12c15.9,0,31.79,0,47.68.12-15.89.11-31.78.08-47.68.13Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "264.675px 331.445px"
    },
    id: "el6z4j3trgvi6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217,325.36l47.67-.13c15.9,0,31.79,0,47.68.13-15.89.11-31.78.08-47.68.12Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "264.675px 325.355px"
    },
    id: "elqe2m8f0xbzi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217,319.28l47.67-.13c15.9.05,31.79,0,47.68.13-15.89.11-31.78.08-47.68.12Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "264.675px 319.275px"
    },
    id: "elooleb9s0io",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "221.3 365.12 234.04 351.98 239.26 354.57 253.02 341.39 256.81 344.32 265.66 339.02 277.92 347.47 280.64 344.54 287.64 350.63 298.63 341.99 305.16 347.25 312.36 345.22 312.36 373.51 221.3 373.51 221.3 365.12",
    style: {
      fill: "rgb(166, 166, 166)",
      transformOrigin: "266.83px 356.265px"
    },
    id: "eldwwx3dfyj7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "221.3 365.19 233.49 362.58 244.95 351.98 249.62 354.9 258.87 346.19 266.25 349.05 269.49 346.5 278.55 355.69 291.32 341.99 301.28 351.98 312.36 346.87 312.36 373.51 221.3 373.51 221.3 365.19",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "266.83px 357.75px"
    },
    id: "ellxkhsx9drpc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "221.58 364.86 237.13 356.45 245.51 360.01 250.09 358.55 255 361.41 267.29 354.5 269.49 357.5 273.76 356.3 282.26 360.01 293.85 355.1 300.81 360.01 312.36 351.65 312.36 373.51 221.58 373.51 221.58 364.86",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "266.97px 362.58px"
    },
    id: "elpgau8sl8zu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220.28,
    y: 316.43,
    width: 1.3,
    height: 57.41,
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "220.93px 345.135px"
    },
    id: "elmqrwxsmm0ri",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elevloeh86q1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 265.7,
    y: 327.18,
    width: 1.23,
    height: 92.08,
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "266.315px 373.22px",
      transform: "rotate(90deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 333.6,
    y: 311.11,
    width: 116.57,
    height: 68.05,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "391.885px 345.135px"
    },
    id: "el9002wr87kx5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 347.84,
    y: 366.49,
    width: 4.9,
    height: 4.85,
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "350.29px 368.915px"
    },
    id: "eltf8p2j9vbb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356.14,
    y: 366.49,
    width: 53.61,
    height: 1.43,
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "382.945px 367.205px"
    },
    id: "el5pe9svnv5ex",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356.14,
    y: 369.91,
    width: 34.64,
    height: 1.43,
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "373.46px 370.625px"
    },
    id: "eljq6fs3r7vj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.51,323.7c15.46-.08,30.92-.06,46.38-.09s30.91,0,46.37.09c-15.46.08-30.91.06-46.37.09S361,323.78,345.51,323.7Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "391.885px 323.699px"
    },
    id: "elk3ppi8ckky",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.51,331.05C361,331,376.43,331,391.89,331s30.91,0,46.37.09c-15.46.07-30.91.05-46.37.09S361,331.12,345.51,331.05Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "391.885px 331.095px"
    },
    id: "el79xpx2fqm6v",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.51,338.39c15.46-.07,30.92-.05,46.38-.09s30.91,0,46.37.09c-15.46.08-30.91.06-46.37.09S361,338.47,345.51,338.39Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "391.885px 338.387px"
    },
    id: "el60sm0hi41dt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.51,345.74c15.46-.08,30.92-.06,46.38-.09s30.91,0,46.37.09c-15.46.08-30.91.06-46.37.09S361,345.82,345.51,345.74Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "391.885px 345.739px"
    },
    id: "eldd1elq2bag",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.51,353.09C361,353,376.43,353,391.89,353s30.91,0,46.37.09c-15.46.07-30.91.05-46.37.09S361,353.16,345.51,353.09Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "391.885px 353.096px"
    },
    id: "elf8zevv3y2sf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.18,318.92c.14,6.87.1,13.73.16,20.6s0,13.73-.16,20.59c-.13-6.86-.1-13.73-.16-20.59S364.05,325.79,364.18,318.92Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "364.182px 339.515px"
    },
    id: "el8cvllvvpiw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.22,318.92c.14,6.87.1,13.73.16,20.6s0,13.73-.16,20.59c-.13-6.86-.1-13.73-.16-20.59S380.09,325.79,380.22,318.92Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "380.222px 339.515px"
    },
    id: "elrhsyqp2ch8k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.26,318.92c.14,6.87.1,13.73.16,20.6s0,13.73-.16,20.59c-.13-6.86-.1-13.73-.16-20.59S396.13,325.79,396.26,318.92Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "396.262px 339.515px"
    },
    id: "ele38kytn4zvq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.3,318.92c.14,6.87.11,13.73.16,20.6s0,13.73-.16,20.59c-.13-6.86-.1-13.73-.15-20.59S412.17,325.79,412.3,318.92Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "412.306px 339.515px"
    },
    id: "elyfywypqlw99",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.34,318.92c.14,6.87.11,13.73.16,20.6s0,13.73-.16,20.59c-.13-6.86-.1-13.73-.15-20.59S428.21,325.79,428.34,318.92Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "428.346px 339.515px"
    },
    id: "elklqzfrysf1r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el3dd4ovjftz5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M347.84,347.76c2.83,0,4.52-7.47,8.53-7.47s4.44,5.45,7.81,5.45,3.27-9.56,7.81-9.56,3.48,3.88,8.23,3.88,3-9,7.92-9,2.95,12.41,8.12,12.41c3.27,0,4.54-3.94,8.45-3.94,2.58,0,4.11,2,7.49,2s4.11-7.58,8.34-7.58,4.7,4.48,7.8,4.48,4.23-7.34,9.92-7.34v29.06H347.84Z",
    style: {
      fill: "rgb(64, 123, 255)",
      opacity: 0.5,
      transformOrigin: "393.05px 345.605px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M347.84,348.12v-.72c.86,0,2-1.74,2.9-3,1.49-2.18,3-4.44,5.63-4.44s3.76,1.65,4.86,3.11c.86,1.15,1.76,2.33,2.95,2.33s2-2.3,2.64-4c1.1-2.75,2.23-5.59,5.17-5.59a5.38,5.38,0,0,1,4.57,2.1,4.3,4.3,0,0,0,3.66,1.78c1.83,0,2.54-2.11,3.23-4.14.82-2.4,1.66-4.87,4.69-4.87s3.77,3.11,4.59,6.42c.66,2.67,1.47,6,3.53,6,1.23,0,2.24-.82,3.31-1.69a7.74,7.74,0,0,1,5.14-2.25,8.68,8.68,0,0,1,3.61,1,9,9,0,0,0,3.87,1c1.18,0,2.24-1.8,3.1-3.25,1.26-2.13,2.57-4.33,5.25-4.33s4,1.43,5.12,2.69c.84.92,1.64,1.79,2.68,1.79s1.91-1.39,2.8-2.62c1.52-2.11,3.42-4.72,7.12-4.72v.71c-2.85,0-4.49,2.28-5.94,4.28-1.25,1.72-2.23,3.07-4,3.07s-2.78-1.06-3.81-2.18-2.11-2.3-4-2.3-3,2-4,3.84c-1.19,2-2.22,3.74-4.31,3.74a10.74,10.74,0,0,1-4.65-1.16,6.94,6.94,0,0,0-2.83-.81c-1.71,0-2.93,1-4.1,1.94s-2.45,2-4.35,2c-3.16,0-3.95-3.21-4.79-6.62-.64-2.58-1.43-5.8-3.33-5.8s-2.76,2.28-3.44,4.29c-.83,2.43-1.6,4.73-4.48,4.73a5.61,5.61,0,0,1-4.78-2.17,4.1,4.1,0,0,0-3.45-1.72c-1.93,0-3,2.79-3.93,5-1,2.54-1.81,4.54-3.88,4.54s-3-1.34-4.12-2.77-2-2.68-3.69-2.68-3.24,2.21-4.44,4C350.61,346.58,349.57,348.12,347.84,348.12Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "393.05px 339.4px"
    },
    id: "elz0l5xmzf8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.84,319.37c.11,6.79.19,13.58.2,20.37l.1,20.37-.3-.17,45.21.05,22.61,0,22.6.09-22.6.09-22.61,0-45.21,0h-.29v-.17l.09-20.37C347.65,333,347.74,326.16,347.84,319.37Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "392.905px 339.77px"
    },
    id: "el0qxz62jv6gc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 461.83,
    y: 311.11,
    width: 83.92,
    height: 68.05,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "503.79px 345.135px"
    },
    id: "elcz6l0pd6bjm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.48,320.39l38.73-.11c12.92,0,13,0,25.88.11-12.91.09-13,.06-25.88.1Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "503.785px 320.385px"
    },
    id: "elrg1j64rh5x",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.48,323.59l38.73-.11c12.92,0,13,0,25.88.11-12.91.09-13,.06-25.88.1Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "503.785px 323.585px"
    },
    id: "elnxm2vwp5h6g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.48,326.79l38.73-.11c12.92,0,13,0,25.88.11-12.91.09-13,.06-25.88.1Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "503.785px 326.785px"
    },
    id: "el9vkt719b4ma",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.48,330l38.73-.1c12.92,0,13,0,25.88.1-12.91.09-13,.07-25.88.11Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "503.785px 330.005px"
    },
    id: "elzleao1l0azh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.48,333.18l38.73-.1c12.92,0,13,0,25.88.1-12.91.09-13,.07-25.88.11Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "503.785px 333.185px"
    },
    id: "elyso5q2z3l3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.48,336.38l38.73-.1c12.92,0,13,0,25.88.1-12.91.09-13,.07-25.88.11Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "503.785px 336.385px"
    },
    id: "ele1crdg5f42j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.48,339.58l38.73-.1c12.92,0,13,0,25.88.1-12.91.09-13,.07-25.88.11Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "503.785px 339.585px"
    },
    id: "elnv3lf27ccbl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.48,342.78l38.73-.1c12.92,0,13,0,25.88.1-12.91.09-13,.07-25.88.11Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "503.785px 342.785px"
    },
    id: "elzi676l0fbd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.48,346l38.73-.1c12.92,0,13,0,25.88.1-12.91.09-13,.07-25.88.1Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "503.785px 346px"
    },
    id: "eljpxu3y0wugk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.48,349.18l38.73-.1c12.92,0,13,0,25.88.1-12.91.09-13,.07-25.88.1Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "503.785px 349.18px"
    },
    id: "elj99skidvkwo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.48,352.38l38.73-.11c12.92,0,13,0,25.88.11-12.91.09-13,.07-25.88.1Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "503.785px 352.375px"
    },
    id: "elkhxkkn4kvn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.48,355.58l38.73-.11c12.92,0,13,0,25.88.11-12.91.09-13,.06-25.88.1Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "503.785px 355.575px"
    },
    id: "elc61wkrcgopq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.48,358.78l38.73-.11c12.92,0,13,0,25.88.11-12.91.09-13,.06-25.88.1Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "503.785px 358.775px"
    },
    id: "eltugo6s8cqxi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.48,362l38.73-.11c12.92,0,13,0,25.88.11-12.91.09-13,.06-25.88.1Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "503.785px 361.995px"
    },
    id: "elp8pebi2ug0g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.48,365.17l38.73-.1c12.92,0,13,0,25.88.1-12.91.09-13,.07-25.88.11Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "503.785px 365.175px"
    },
    id: "el3jtqcfts5im",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 479.67,
    y: 342.78,
    width: 5.87,
    height: 26.12,
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "482.605px 355.84px"
    },
    id: "el7anbfts7m23",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 490.57,
    y: 331.73,
    width: 5.87,
    height: 37.17,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "493.505px 350.315px"
    },
    id: "elmdfyhbsefvd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 501.47,
    y: 339.69,
    width: 5.87,
    height: 29.21,
    style: {
      fill: "rgb(166, 166, 166)",
      transformOrigin: "504.405px 354.295px"
    },
    id: "elcgrmrmarnj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 512.37,
    y: 329.98,
    width: 5.87,
    height: 38.92,
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "515.305px 349.44px"
    },
    id: "eln9wsh3es029",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 523.26,
    y: 335.2,
    width: 5.87,
    height: 33.7,
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "526.195px 352.05px"
    },
    id: "elmbtughanrp7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.58,318.14l.16,12.69.11,12.69c.08,8.46.1,16.92.11,25.38l-.38-.38,18.84,0,18.85.05,18.84.12,6,.23-6,.23-18.84.13-18.85.05-18.84,0h-.38v-.39c0-8.46,0-16.92.11-25.38l.11-12.69Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "504.655px 343.735px"
    },
    id: "elg2bi7budia9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 479.67,
    y: 371.59,
    width: 5.87,
    height: 0.54,
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "482.605px 371.86px"
    },
    id: "eltvogsn3ez0f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 490.57,
    y: 371.59,
    width: 5.87,
    height: 0.54,
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "493.505px 371.86px"
    },
    id: "eli3qfadzn6y",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 501.47,
    y: 371.59,
    width: 5.87,
    height: 0.54,
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "504.405px 371.86px"
    },
    id: "ela4rcsvv6xvh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 512.37,
    y: 371.59,
    width: 5.87,
    height: 0.54,
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "515.305px 371.86px"
    },
    id: "elqrs8hexb3l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 523.26,
    y: 371.59,
    width: 5.87,
    height: 0.54,
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "526.195px 371.86px"
    },
    id: "el8fs77g3zkur",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-517",
    className: "animable",
    style: {
      transformOrigin: "651.335px 365.505px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M643.25,376.87s-16.59-3.76-25.68-12.14-14.18-23.39-14.18-23.39A142.62,142.62,0,0,1,622,346.23a31.55,31.55,0,0,1,5.63,8,37.83,37.83,0,0,0,0-5.69,25.17,25.17,0,0,1,5.91,3.58C641.12,358.68,643.25,376.87,643.25,376.87Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "623.32px 359.105px"
    },
    id: "elrmiyze2zn7f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.75,348.64c-2.26-1.57-4.56-3.08-6.81-4.66-.14-.09,0-.31.13-.22,4.28,2.55,8.49,5.28,12.57,8.14,1.42,1,2.82,2,4.2,3.09l-.29-.49c-.5-.83-1-1.65-1.55-2.47a35.75,35.75,0,0,0-3.52-4.7c-.05-.05,0-.13.08-.08,1.29,1.49,2.58,3,3.76,4.55.56.75,1.08,1.53,1.58,2.32.26.42.5.83.74,1.26.08.14.17.28.25.43,2.15,1.68,4.24,3.44,6.23,5.29q1.85,1.72,3.56,3.56c-.64-2-1.2-4-1.94-6,0-.07.08-.1.11,0,.72,2.07,1.51,4.16,2.07,6.29q1.91,2.05,3.63,4.27l-.06-.27c-.19-.78-.39-1.56-.59-2.33-.41-1.51-.85-3-1.36-4.47a25.77,25.77,0,0,0-4.45-8.41c-.05-.06,0-.14.08-.08a32.36,32.36,0,0,1,6.35,13.27c.18.7.35,1.41.51,2.12.08.38.18.76.25,1.15.5.68,1,1.36,1.46,2.06a71.71,71.71,0,0,1,7,13.77,160.53,160.53,0,0,1,5.32,16.57c0,.11-.14.15-.17,0-3.24-9.7-6.56-19.55-12.11-28.23-1.18-1.83-2.44-3.59-3.79-5.3a31.31,31.31,0,0,1-8.07-1.6,36.1,36.1,0,0,1-8.08-3.91,48.46,48.46,0,0,1-4.15-3.13.06.06,0,1,1,.07-.09,33.17,33.17,0,0,0,7.61,4.61,41,41,0,0,0,8.37,2.8c1.22.27,2.46.47,3.71.64a69.85,69.85,0,0,0-4.9-5.42c-.56-.56-1.14-1.1-1.71-1.64a39.64,39.64,0,0,0-6.13-3.51c-2.72-1.31-5.4-2.71-8.09-4.07-1.52-.78-3-1.57-4.55-2.31a.06.06,0,0,1,0-.1c2.73,1.32,5.5,2.55,8.25,3.81,2.59,1.19,5.21,2.38,7.7,3.77l.31.19c-2.24-2-4.57-3.82-6.95-5.62C618.25,351.83,616,350.2,613.75,348.64Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "629.971px 373.218px"
    },
    id: "eldst6q0wwzbt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M614.7,357.19c1.34.59,2.72,1.11,4,1.74a44.87,44.87,0,0,1,4,2.16.05.05,0,1,1-.05.09c-1.32-.63-2.66-1.22-4-1.88s-2.67-1.4-4.05-2C614.6,357.27,614.63,357.16,614.7,357.19Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "618.663px 359.186px"
    },
    id: "elcoszx7whkgu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M697.14,293.26a23.72,23.72,0,0,0-5,13.78c0,1.49.18,3.56.35,6a39.35,39.35,0,0,0-10.82,9.25,19.66,19.66,0,0,1,10.94-2.62,33.66,33.66,0,0,1-.63,5,18.81,18.81,0,0,0-7,1.39,15.75,15.75,0,0,1,6.34,1.26c-3,9.41-11.74,19.08-36,23.18a51,51,0,0,1,4.3-34.16C666.88,302,697.14,293.26,697.14,293.26Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "675.62px 321.88px"
    },
    id: "el5wd7fpwktlj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M646.9,390.72q.63-6,1.57-12c1.25-8,2.86-15.94,4.9-23.76a95.63,95.63,0,0,1,3.5-10.83,18,18,0,0,1-.09-1.94c0-.78,0-1.56,0-2.33,0-1.56.09-3.11.22-4.66a54.85,54.85,0,0,1,1.5-9.1c.44-1.73,1-3.43,1.46-5.14a.06.06,0,0,1,.11,0,66.86,66.86,0,0,0-1.79,9.08,84.45,84.45,0,0,0-.82,9.11c0,.84,0,1.67,0,2.51,0,.35,0,.71,0,1.07a80.41,80.41,0,0,1,4.09-8.47,103.48,103.48,0,0,1,8.31-12.43,5.26,5.26,0,0,1,.2-1.36c.12-.54.23-1.08.35-1.62.25-1.11.53-2.21.83-3.31.61-2.2,1.4-4.32,2.09-6.49a.06.06,0,0,1,.11,0c-.64,2.15-1.07,4.38-1.56,6.56l-.72,3.25c-.12.54-.23,1.09-.35,1.63a.5.5,0,0,1,0,.12q1.47-1.86,3-3.66c4.63-5.43,9.71-10.45,14.83-15.43.63-.61,1.27-1.21,1.91-1.81,0-.05.13,0,.08.08-4.89,5.1-9.7,10.26-14.26,15.66q-1.62,1.92-3.2,3.9c.55-.38,1.11-.74,1.66-1.1,1.41-.93,2.84-1.82,4.31-2.65s3-1.63,4.47-2.38,3.22-1.4,4.73-2.27c.06,0,.12.07.05.1a34.81,34.81,0,0,0-4.43,2.45q-2.22,1.31-4.4,2.68c-1.43.9-2.86,1.79-4.28,2.72-1.18.76-2.34,1.6-3.57,2.31a113.39,113.39,0,0,0-7.77,11.32,81.54,81.54,0,0,0-4,7.62l.87-.38,2.22-1c1.43-.64,2.86-1.26,4.29-1.88,2.73-1.18,5.49-2.27,8.16-3.57a37.8,37.8,0,0,0,4.36-2.42c.06,0,.11.06.05.1-5,3.43-10.55,5.85-16.06,8.28l-2.39,1.06c-.66.29-1.31.62-2,.87a83.47,83.47,0,0,0-4.1,11.25A229.57,229.57,0,0,0,650,376c-1.39,7.93-2.33,15.91-3.06,23.92-.09,1-.18,2-.29,3,0,.4-.64.4-.63,0C646.06,398.84,646.48,394.76,646.9,390.72Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "668.331px 351.455px"
    },
    id: "el6ytvhvz0e38",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M661.67,323.69c.44-2.47,1.1-4.88,1.77-7.3a.05.05,0,1,1,.1,0c-.61,2.37-1,4.79-1.49,7.2s-.86,4.92-1.21,7.39a0,0,0,1,1-.06,0A64.25,64.25,0,0,1,661.67,323.69Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "662.16px 323.659px"
    },
    id: "elk6arrq5q71",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M672.13,330.38a42,42,0,0,1,5.28-3c.88-.46,1.78-.89,2.68-1.33s1.88-.82,2.8-1.28c.06,0,.12.07.05.1-.89.44-1.73,1-2.6,1.46s-1.79,1-2.7,1.47c-1.77,1-3.52,2-5.38,2.79A.14.14,0,0,1,672.13,330.38Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "677.541px 327.68px"
    },
    id: "elgs6dwffx52k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elf0plvyptg0h"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M643,348.13s-15.35-3.67-22.4-14c-6.73-9.83-8.91-26.59-9.08-28.07.27,1.35,3.44,16,13.89,22.83C633.36,334.15,641.1,338.45,643,348.13Z",
    style: {
      fill: "rgb(38, 50, 56)",
      opacity: 0.1,
      transformOrigin: "627.26px 327.095px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M628.78,321.61a19.6,19.6,0,0,1,5.66,9.32,0,0,0,1,1-.05,0,23,23,0,0,0-5.69-9.25C628.65,321.64,628.73,321.56,628.78,321.61Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "631.562px 326.262px"
    },
    id: "elgi7w2hims9l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643,348.13s-15.35-3.67-22.4-14c-6.73-9.83-8.91-26.59-9.08-28.07a.42.42,0,0,1,0-.1s7.36,10.46,15.1,13.13S645.17,331,643,348.13Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "627.4px 327.045px"
    },
    id: "elzlps3irsdvq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M614.17,311.76a62.85,62.85,0,0,0,4.75,8.12,32.34,32.34,0,0,0,6.31,6.49c2.09,1.66,4.29,3.16,6.4,4.78l0-.07c-.39-.59-.82-1.16-1.25-1.72-.88-1.12-1.84-2.18-2.81-3.23-1.91-2.07-3.85-4.1-5.56-6.34a23.52,23.52,0,0,1-2.47-4c0-.06.08-.1.11,0,2.49,5.18,7.46,8.5,11,12.89a21,21,0,0,1,1.42,1.94,7.66,7.66,0,0,1,.88,1.56,32,32,0,0,1,5.24,5.29,22.81,22.81,0,0,0-.61-3,15.49,15.49,0,0,0-1.63-3.89c0-.06.06-.12.09-.06a18,18,0,0,1,1.79,3.86,13.5,13.5,0,0,1,.56,3.32h0a28.86,28.86,0,0,1,2.07,3.22c-.06-.33-.12-.65-.19-1-.3-1.53-.64-3.06-1-4.56a27.19,27.19,0,0,0-3.69-8.65.06.06,0,0,1,.1-.07,33.14,33.14,0,0,1,4.09,8.47c.49,1.5.88,3,1.22,4.58.17.75.32,1.51.47,2.27.07.4.16.8.22,1.2a55.07,55.07,0,0,1,3.54,10.41A153.31,153.31,0,0,1,648.43,373a161.22,161.22,0,0,1,1.05,20.61c0,.86-.06,1.72-.11,2.59,0,.22-.34.25-.35,0-.15-3.41-.24-6.82-.44-10.22s-.5-6.81-.87-10.2a179.89,179.89,0,0,0-3.2-19.85c-1.24-5.61-2.85-11.26-5.92-16.18a30.63,30.63,0,0,0-5.54-6.58c-2.15-1.93-4.51-3.63-6.78-5.42a37.33,37.33,0,0,1-6.21-6,48.8,48.8,0,0,1-4.88-7.93c-.37-.69-.74-1.38-1.1-2.08C614,311.76,614.14,311.7,614.17,311.76Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "631.775px 354.054px"
    },
    id: "el3lhizl85gd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.82,314a51.28,51.28,0,0,0,3.42,6,0,0,0,0,1-.07.05,42,42,0,0,1-3.46-6C616.68,314,616.79,314,616.82,314Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "618.472px 317.025px"
    },
    id: "elq82efyb89on",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M699.28,341.34s.24,21.82-12.8,28.11-20,1.06-28.9,3.17v0c.35-.52,6.67-9.61,16.74-12.11C684.67,357.91,696.14,350.43,699.28,341.34Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "678.43px 357.009px"
    },
    id: "elirxg96ec0r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elhju5mlbqf5h"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M699.28,341.34s.24,21.82-12.8,28.11-20,1.06-28.9,3.17v0a49.79,49.79,0,0,1,14.83-4.37C680.65,367.24,696.36,361.88,699.28,341.34Z",
    style: {
      opacity: 0.1,
      transformOrigin: "678.43px 357.009px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M656.72,373a22.26,22.26,0,0,1,5.19-3.51c.28-.13.57-.24.85-.36a5.24,5.24,0,0,1,.44-.5q.59-.61,1.23-1.17a18,18,0,0,1,2.62-1.89c2.16-1.27,4.53-2.16,6.74-3.34.06,0,.12.06.05.1-1.09.56-2.15,1.19-3.21,1.81s-2.09,1.18-3.1,1.83A21.93,21.93,0,0,0,665,367.9c-.23.2-.45.42-.67.64a35.36,35.36,0,0,1,4.41-1.17c2.39-.48,4.8-.82,7.19-1.33a34.62,34.62,0,0,0,3.46-.93c1.08-.88,2.16-1.74,3.19-2.69a26.61,26.61,0,0,0,3.37-3.74c0-.05.14,0,.09.06a39.82,39.82,0,0,1-5.34,5.9c.56-.21,1.11-.44,1.66-.69a26.89,26.89,0,0,0,11.12-9.24c0-.06.14,0,.09.05a30.36,30.36,0,0,1-9,8.64,27.1,27.1,0,0,1-5.68,2.69,54.87,54.87,0,0,1-7.06,1.67,49.58,49.58,0,0,0-6.91,1.64,20.91,20.91,0,0,0-5.8,3.05,27.2,27.2,0,0,0-7.82,9.69,49,49,0,0,0-4.3,15.95c0,.24-.39.24-.37,0C647.2,388.91,649.65,379.37,656.72,373Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "670.105px 376.477px"
    },
    id: "el964jp6351s5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M671.86,365.89a7.54,7.54,0,0,1,2.68-2.43,9.81,9.81,0,0,0,3.19-2.64c0-.06.14,0,.09.06A10.73,10.73,0,0,1,675,363.4a9.94,9.94,0,0,0-3.07,2.54C671.9,366,671.82,365.94,671.86,365.89Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "674.84px 363.38px"
    },
    id: "el8yklpqii6dk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "664.94 389.11 664.34 401.1 662.52 437.75 635.16 437.75 633.34 401.1 632.75 389.11 664.94 389.11",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "648.845px 413.43px"
    },
    id: "elvahfqlzool",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "664.94 389.11 664.34 401.1 633.34 401.1 632.75 389.11 664.94 389.11",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "648.845px 395.105px"
    },
    id: "el6txo95tz4xs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 630.83,
    y: 384.1,
    width: 36.03,
    height: 11.44,
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "648.845px 389.82px"
    },
    id: "elx8u922fike",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Files--inject-517",
    className: "animable",
    style: {
      transformOrigin: "646.48px 234.11px"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "680.42 256.48 602.95 256.48 602.94 157.03 668.58 157.02 680.41 168.86 680.42 256.48",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "641.68px 206.75px"
    },
    id: "elyqxkcvj6fo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M680.42,256.48l-77.47.06h-.06v-.06L602.82,157v-.12h.12l65.64,0h0l0,0,11.83,11.84,0,0v0Zm0,0-.07-87.62,0,0-11.84-11.82.05,0-65.64.05.12-.12L603,256.48l0-.05Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "641.62px 206.71px"
    },
    id: "elexr3jbvgva5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "611.42 178.28 641.68 178.21 671.94 178.28 641.68 178.36 611.42 178.28",
    style: {
      fill: "rgb(199, 199, 199)",
      transformOrigin: "641.68px 178.285px"
    },
    id: "el8qytrdcbhyf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "611.42 180.75 641.68 180.67 671.94 180.75 641.68 180.83 611.42 180.75",
    style: {
      fill: "rgb(199, 199, 199)",
      transformOrigin: "641.68px 180.75px"
    },
    id: "elghj4zfxy5s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "611.42 183.22 641.68 183.14 671.94 183.22 641.68 183.29 611.42 183.22",
    style: {
      fill: "rgb(199, 199, 199)",
      transformOrigin: "641.68px 183.215px"
    },
    id: "elloro8gua5x",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "611.42 185.69 641.68 185.61 671.94 185.68 641.68 185.76 611.42 185.69",
    style: {
      fill: "rgb(199, 199, 199)",
      transformOrigin: "641.68px 185.685px"
    },
    id: "elo11xq7utmg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "611.42 188.16 641.68 188.08 671.94 188.15 641.68 188.23 611.42 188.16",
    style: {
      fill: "rgb(199, 199, 199)",
      transformOrigin: "641.68px 188.155px"
    },
    id: "el9ucsgnmt76a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "611.42 190.63 641.68 190.55 671.94 190.62 641.68 190.7 611.42 190.63",
    style: {
      fill: "rgb(199, 199, 199)",
      transformOrigin: "641.68px 190.625px"
    },
    id: "eljz7tz5s6kxb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "611.42 193.09 641.68 193.01 671.94 193.09 641.68 193.17 611.42 193.09",
    style: {
      fill: "rgb(199, 199, 199)",
      transformOrigin: "641.68px 193.09px"
    },
    id: "eluyjokztu1ft",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "611.42 195.56 641.68 195.48 671.94 195.56 641.68 195.63 611.42 195.56",
    style: {
      fill: "rgb(199, 199, 199)",
      transformOrigin: "641.68px 195.555px"
    },
    id: "eln4xe3u6irln",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "611.42 198.03 641.68 197.95 671.94 198.02 641.68 198.1 611.42 198.03",
    style: {
      fill: "rgb(199, 199, 199)",
      transformOrigin: "641.68px 198.025px"
    },
    id: "elk6gohhgjvdp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "611.42 200.5 641.68 200.42 671.94 200.49 641.68 200.57 611.42 200.5",
    style: {
      fill: "rgb(199, 199, 199)",
      transformOrigin: "641.68px 200.495px"
    },
    id: "elsk1pwhewaah",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "611.42 202.97 641.68 202.89 671.94 202.96 641.68 203.04 611.42 202.97",
    style: {
      fill: "rgb(199, 199, 199)",
      transformOrigin: "641.68px 202.965px"
    },
    id: "el9v0yjyfu7pr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "611.42 205.43 641.68 205.35 671.94 205.43 641.68 205.51 611.42 205.43",
    style: {
      fill: "rgb(199, 199, 199)",
      transformOrigin: "641.68px 205.43px"
    },
    id: "elrausj21mc5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "611.42 207.9 641.68 207.82 671.94 207.9 641.68 207.97 611.42 207.9",
    style: {
      fill: "rgb(199, 199, 199)",
      transformOrigin: "641.68px 207.895px"
    },
    id: "elrq1hpsgk0zb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "611.42 210.37 641.68 210.29 671.94 210.37 641.68 210.44 611.42 210.37",
    style: {
      fill: "rgb(199, 199, 199)",
      transformOrigin: "641.68px 210.365px"
    },
    id: "el9dxhtest4sg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "611.42 212.84 641.68 212.76 671.94 212.83 641.68 212.91 611.42 212.84",
    style: {
      fill: "rgb(199, 199, 199)",
      transformOrigin: "641.68px 212.835px"
    },
    id: "elhnfb0ixww2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 617.82,
    y: 205.36,
    width: 4.59,
    height: 10.36,
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "620.115px 210.54px"
    },
    id: "eldfc6zgpuvyv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 626.33,
    y: 199.83,
    width: 4.59,
    height: 15.88,
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "628.625px 207.77px"
    },
    id: "elgdmej9rb9lw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 634.85,
    y: 193.65,
    width: 4.59,
    height: 22.07,
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "637.145px 204.685px"
    },
    id: "el5ax2hdguw3c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 643.36,
    y: 190.99,
    width: 4.59,
    height: 24.72,
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "645.655px 203.35px"
    },
    id: "eleqqs1q6hl56",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 651.88,
    y: 186.25,
    width: 4.59,
    height: 29.46,
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "654.175px 200.98px"
    },
    id: "elskpt7jv2mx",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 660.39,
    y: 181.57,
    width: 4.59,
    height: 34.14,
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "662.685px 198.64px"
    },
    id: "elcl3tba88pku",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.06,176.55l.12,9.79.08,9.79c.06,6.53.07,13.06.09,19.58l-.29-.28h14.72l14.72,0,14.72.09,14.72.17-14.72.17L642.5,216l-14.72,0h-15v-.29c0-6.52,0-13.05.08-19.58l.08-9.79Z",
    style: {
      fill: "rgb(199, 199, 199)",
      transformOrigin: "642.36px 196.275px"
    },
    id: "elcxj88p8ps",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 617.82,
    y: 217.78,
    width: 4.59,
    height: 0.42,
    style: {
      fill: "rgb(199, 199, 199)",
      transformOrigin: "620.115px 217.99px"
    },
    id: "el0vkp5nygapt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 626.33,
    y: 217.78,
    width: 4.59,
    height: 0.42,
    style: {
      fill: "rgb(199, 199, 199)",
      transformOrigin: "628.625px 217.99px"
    },
    id: "elcpmwqux8bmf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 634.85,
    y: 217.78,
    width: 4.59,
    height: 0.42,
    style: {
      fill: "rgb(199, 199, 199)",
      transformOrigin: "637.145px 217.99px"
    },
    id: "elib81kuwdn3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 643.36,
    y: 217.78,
    width: 4.59,
    height: 0.41,
    style: {
      fill: "rgb(199, 199, 199)",
      transformOrigin: "645.655px 217.985px"
    },
    id: "elia6uysfyc9f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 651.88,
    y: 217.78,
    width: 4.59,
    height: 0.41,
    style: {
      fill: "rgb(199, 199, 199)",
      transformOrigin: "654.175px 217.985px"
    },
    id: "elj34paybqzfb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 660.39,
    y: 217.78,
    width: 4.59,
    height: 0.41,
    style: {
      fill: "rgb(199, 199, 199)",
      transformOrigin: "662.685px 217.985px"
    },
    id: "elzj1d00nwadh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618.34,206.66a55.64,55.64,0,0,0,6.7-.51,61.22,61.22,0,0,0,6.6-1.19,57.08,57.08,0,0,0,12.61-4.44,44.83,44.83,0,0,0,11-7.5l.62-.57.59-.59,1.17-1.2c.72-.85,1.5-1.66,2.16-2.56a47.67,47.67,0,0,0,3.76-5.57l0,0a40,40,0,0,1-8,10.84,39.24,39.24,0,0,1-5.25,4.28,44.41,44.41,0,0,1-5.84,3.43,54.71,54.71,0,0,1-12.79,4.35A55.5,55.5,0,0,1,618.34,206.66Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "640.945px 194.607px"
    },
    id: "el1p6fpwu1vjdj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "664.87 185.73 664.23 185.88 663.45 182.75 660.38 183.76 660.18 183.14 663.91 181.91 664.87 185.73",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "662.525px 183.895px"
    },
    id: "elwxs3wrlwajp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elm5txpjs36qb"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 610.13,
    y: 231.11,
    width: 63.11,
    height: 2.55,
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "641.685px 232.385px",
      transform: "rotate(180deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elypet01cqzgd"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 610.13,
    y: 237.56,
    width: 35.53,
    height: 2.55,
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "627.895px 238.835px",
      transform: "rotate(180deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el84dqui5dh54"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 623.91,
    y: 168.02,
    width: 35.53,
    height: 2.55,
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "641.675px 169.295px",
      transform: "rotate(180deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "680.42 168.86 668.58 168.86 668.58 157.02 680.42 168.86",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "674.5px 162.94px"
    },
    id: "elfmf58bv3r0e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "698.84 333.73 621.37 333.73 621.36 234.28 687 234.28 698.84 246.11 698.84 333.73",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "660.1px 284.005px"
    },
    id: "elfxva2kevajb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M698.84,333.73l-77.47.06h-.06v-.06l-.07-99.45v-.12h.12l65.64,0h0l0,0,11.82,11.84,0,0v0Zm0,0-.07-87.62,0,0L687,234.33l0,0-65.64.05.12-.12-.06,99.45,0-.05Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "660.04px 283.975px"
    },
    id: "el0wbuh3tp5xo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elnwse7myfrn"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 642.33,
    y: 245.27,
    width: 35.53,
    height: 2.55,
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "660.095px 246.545px",
      transform: "rotate(180deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "698.84 246.12 687 246.12 687 234.27 698.84 246.12",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "692.92px 240.195px"
    },
    id: "elj4u2493gj0n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M645.08,264.42a5.85,5.85,0,1,1-.77-2.92A5.87,5.87,0,0,1,645.08,264.42Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "639.23px 264.401px"
    },
    id: "el2khtu9kghne",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.31,261.5l-5.1,2.92v-5.87A5.87,5.87,0,0,1,644.31,261.5Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "641.76px 261.485px"
    },
    id: "elsl3hbmvhzd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643.27,264.42a4.06,4.06,0,1,1-4.06-4.06A4.06,4.06,0,0,1,643.27,264.42Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "639.21px 264.42px"
    },
    id: "elemnwdlow5m7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 637.52,
    y: 263.51,
    width: 3.38,
    height: 0.48,
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "639.21px 263.75px"
    },
    id: "elw1f5mzs5f2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 636.68,
    y: 264.84,
    width: 5.06,
    height: 0.48,
    style: {
      fill: "rgb(166, 166, 166)",
      transformOrigin: "639.21px 265.08px"
    },
    id: "elpjpb7dkna4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M645.08,279.58a6.11,6.11,0,0,1-.06.86,6,6,0,1,1,.06-.86Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "639.08px 279.594px"
    },
    id: "elhqdgreab235",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M645.08,279.58a6.11,6.11,0,0,1-.06.86l-5.81-.86v-5.87a5.85,5.85,0,0,1,5.87,5.87Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "642.145px 277.075px"
    },
    id: "elc78mddw1819",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643.27,279.58a4.06,4.06,0,1,1-4.06-4.06A4.06,4.06,0,0,1,643.27,279.58Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "639.21px 279.58px"
    },
    id: "ely1a9szpmm0n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 637.52,
    y: 278.68,
    width: 3.38,
    height: 0.48,
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "639.21px 278.92px"
    },
    id: "eliswuhks8ak",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 636.68,
    y: 280,
    width: 5.06,
    height: 0.48,
    style: {
      fill: "rgb(166, 166, 166)",
      transformOrigin: "639.21px 280.24px"
    },
    id: "elwx28d13f8uq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M675.3,264.42a5.87,5.87,0,0,1-3.76,5.48,5.94,5.94,0,0,1-2.11.39,5.88,5.88,0,1,1,5.87-5.87Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "669.42px 264.41px"
    },
    id: "el06t58nnug4ix",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M675.3,264.42a5.87,5.87,0,0,1-3.76,5.48l-2.11-5.48v-5.87a5.85,5.85,0,0,1,5.87,5.87Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "672.365px 264.225px"
    },
    id: "elrssgiqn034",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M673.49,264.42a4.06,4.06,0,1,1-4.06-4.06A4.06,4.06,0,0,1,673.49,264.42Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "669.43px 264.42px"
    },
    id: "eluwcz6ylv6x",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 667.74,
    y: 263.51,
    width: 3.38,
    height: 0.48,
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "669.43px 263.75px"
    },
    id: "elu1k6pghnfaq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 666.91,
    y: 264.84,
    width: 5.06,
    height: 0.48,
    style: {
      fill: "rgb(166, 166, 166)",
      transformOrigin: "669.44px 265.08px"
    },
    id: "el1ugu5rpwwv9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M675.3,279.58a5.85,5.85,0,1,1-.77-2.92A5.84,5.84,0,0,1,675.3,279.58Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "669.45px 279.561px"
    },
    id: "el53e69oyzpti",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M675.3,279.58a5.87,5.87,0,0,1-9.68,4.46l3.81-4.46v-5.87a5.85,5.85,0,0,1,5.87,5.87Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "670.46px 279.577px"
    },
    id: "eluqlhc107xmg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M673.49,279.58a4.06,4.06,0,1,1-4.06-4.06A4.06,4.06,0,0,1,673.49,279.58Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "669.43px 279.58px"
    },
    id: "eln25gbua06sa",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 667.74,
    y: 278.68,
    width: 3.38,
    height: 0.48,
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "669.43px 278.92px"
    },
    id: "el0999mji54td4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 666.9,
    y: 280,
    width: 5.06,
    height: 0.48,
    style: {
      fill: "rgb(166, 166, 166)",
      transformOrigin: "669.43px 280.24px"
    },
    id: "elz6euf3ws6em",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 648.66,
    y: 262.61,
    width: 7.98,
    height: 0.45,
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "652.65px 262.835px"
    },
    id: "elljsc9mlfbqq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 648.66,
    y: 264.19,
    width: 7.98,
    height: 0.45,
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "652.65px 264.415px"
    },
    id: "elxnorgup3y3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 648.66,
    y: 265.77,
    width: 7.98,
    height: 0.45,
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "652.65px 265.995px"
    },
    id: "ele0s7vgmabr8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 648.66,
    y: 277.77,
    width: 7.98,
    height: 0.45,
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "652.65px 277.995px"
    },
    id: "elbw1vnxznhqj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 648.66,
    y: 279.35,
    width: 7.98,
    height: 0.45,
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "652.65px 279.575px"
    },
    id: "el9ffxnw759d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 648.66,
    y: 280.93,
    width: 7.98,
    height: 0.45,
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "652.65px 281.155px"
    },
    id: "el6hsbdl9be9g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 678.88,
    y: 262.61,
    width: 7.98,
    height: 0.45,
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "682.87px 262.835px"
    },
    id: "ela3re77efskt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 678.88,
    y: 264.19,
    width: 7.98,
    height: 0.45,
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "682.87px 264.415px"
    },
    id: "eln86ftcbv5qg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 678.88,
    y: 265.77,
    width: 7.98,
    height: 0.45,
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "682.87px 265.995px"
    },
    id: "elbaodzp2dhht",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 678.88,
    y: 277.77,
    width: 7.98,
    height: 0.45,
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "682.87px 277.995px"
    },
    id: "el50fviuk1rbo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 678.88,
    y: 279.35,
    width: 7.98,
    height: 0.45,
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "682.87px 279.575px"
    },
    id: "elzi5emc7nc3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 678.88,
    y: 280.93,
    width: 7.98,
    height: 0.45,
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "682.87px 281.155px"
    },
    id: "elfq03voqhar9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M657.08,293.76c5-.1,9.92-.08,14.89-.12s9.92,0,14.89.12c-5,.11-9.93.09-14.89.13S662,293.87,657.08,293.76Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "671.97px 293.764px"
    },
    id: "eluhvjutgvuv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M657.08,296.6c5-.11,9.92-.08,14.89-.13s9.92,0,14.89.13c-5,.1-9.93.08-14.89.12S662,296.7,657.08,296.6Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "671.97px 296.592px"
    },
    id: "elzvmwoek5xkq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M657.08,299.43c5-.11,9.92-.08,14.89-.13s9.92,0,14.89.13c-5,.11-9.93.08-14.89.12S662,299.54,657.08,299.43Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "671.97px 299.422px"
    },
    id: "ellrcwlscpo6f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M657.08,302.26c5-.11,9.92-.08,14.89-.12s9.92,0,14.89.12c-5,.11-9.93.08-14.89.13S662,302.37,657.08,302.26Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "671.97px 302.266px"
    },
    id: "el2mf4icmzk8j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M657.08,305.09C662,305,667,305,672,305s9.92,0,14.89.12c-5,.11-9.93.08-14.89.13S662,305.2,657.08,305.09Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "671.985px 305.132px"
    },
    id: "elae8uli3bavm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M657.08,307.92c2.58-.1,5.17-.08,7.76-.12s5.17,0,7.76.12c-2.59.11-5.18.08-7.76.13S659.66,308,657.08,307.92Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "664.84px 307.924px"
    },
    id: "elokoq5w6s3uq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M633.34,315.87c8.92-.11,17.84-.08,26.76-.12s17.84,0,26.76.12c-8.92.11-17.84.08-26.76.13S642.26,316,633.34,315.87Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "660.1px 315.877px"
    },
    id: "el64ulze25w6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M633.34,318.7c8.92-.1,17.84-.08,26.76-.12s17.84,0,26.76.12c-8.92.11-17.84.08-26.76.13S642.26,318.81,633.34,318.7Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "660.1px 318.706px"
    },
    id: "elaxw8bor4dcu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M633.34,321.53c4.65-.1,9.3-.08,13.95-.12s9.3,0,13.94.12c-4.64.11-9.29.09-13.94.13S638,321.64,633.34,321.53Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "647.285px 321.534px"
    },
    id: "eldhutu29b91",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648.71,304.79l.2-.34-.2.34Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "648.81px 304.62px"
    },
    id: "elhk9eoigv8d4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648.91,304.45a6.61,6.61,0,0,0,.73-1.85A6.32,6.32,0,0,1,648.91,304.45Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "649.275px 303.525px"
    },
    id: "elz5blxfra3q",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M652.62,301.79a.68.68,0,0,1,0,.15.77.77,0,0,0,0-.15Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "652.622px 301.865px"
    },
    id: "eli9ho2rfb56h",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M652.65,301.05c0,.11,0,.21,0,.31s0,.29,0,.43a.77.77,0,0,1,0,.15.71.71,0,0,1,0,.15v.05c0,.11,0,.22-.05.33s0,.07,0,.11,0,.28-.08.42-.05.26-.08.38,0,.12,0,.18-.05.19-.08.28a1.42,1.42,0,0,1-.07.22c-.07.22-.15.44-.24.65l-.09.22c-.06.13-.11.25-.18.37a2.1,2.1,0,0,1-.15.3c-.06.12-.13.24-.2.36l-.15.24-2.45-1.41.2-.34a6.32,6.32,0,0,0,.73-1.85,2.57,2.57,0,0,0,.08-.4,2.7,2.7,0,0,0,.06-.41c0-.14,0-.28,0-.43s0-.2,0-.3a1.69,1.69,0,0,0,0-.23,1.34,1.34,0,0,0,0-.2v-.07c0-.13,0-.26,0-.39a.63.63,0,0,0,0-.19c0-.15-.05-.3-.08-.44a5.91,5.91,0,0,0-.24-.82c0-.06,0-.13-.08-.19a1.67,1.67,0,0,0-.08-.2l-.08-.19-.07-.13c0-.09-.09-.18-.14-.27s-.13-.22-.2-.33a7.7,7.7,0,0,0-.48-.67,7.32,7.32,0,0,0-.87-.89,6.48,6.48,0,0,0-.67-.5l1.42-2.45c.21.13.41.28.61.42l.36.28h0l.35.3.3.29.05.05.29.3.07.08.24.29.29.36.26.36,0,.06.18.28.06.09.21.39a7.61,7.61,0,0,1,.4.81s0,0,0,0,.12.29.17.43l.15.42a.43.43,0,0,1,0,0c0,.12.08.24.11.37l0,.16c.07.28.12.56.17.84v0c0,.15,0,.29.05.44a.13.13,0,0,1,0,.06c0,.15,0,.3,0,.44v.06C652.65,300.75,652.65,300.9,652.65,301.05Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "649.782px 299.55px"
    },
    id: "elihrtz51ik9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M646.74,295.35a6.48,6.48,0,0,1,.67.5C647.19,295.67,647,295.51,646.74,295.35Z",
    style: {
      fill: "rgb(166, 166, 166)",
      transformOrigin: "647.075px 295.6px"
    },
    id: "el96x8rt7g5rt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648.28,296.74a8.14,8.14,0,0,0-.87-.89A7.32,7.32,0,0,1,648.28,296.74Z",
    style: {
      fill: "rgb(166, 166, 166)",
      transformOrigin: "647.845px 296.295px"
    },
    id: "eliqd7eawvcd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648.34,293l-.18-.12h0Z",
    style: {
      fill: "rgb(166, 166, 166)",
      transformOrigin: "648.25px 292.94px"
    },
    id: "el3gcy5hxmoz",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648.77,293.32l-.43-.3Z",
    style: {
      fill: "rgb(166, 166, 166)",
      transformOrigin: "648.555px 293.17px"
    },
    id: "el43m3veb1leg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M649.41,298.72a5.91,5.91,0,0,1,.24.82C649.58,299.26,649.5,299,649.41,298.72Z",
    style: {
      fill: "rgb(166, 166, 166)",
      transformOrigin: "649.53px 299.13px"
    },
    id: "elg1615luhbyh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M649.81,300.83a1.69,1.69,0,0,1,0,.23c0,.1,0,.2,0,.3h0c0-.1,0-.2,0-.31A1.62,1.62,0,0,0,649.81,300.83Z",
    style: {
      fill: "rgb(166, 166, 166)",
      transformOrigin: "649.812px 301.095px"
    },
    id: "ely09ph27s5ik",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M647.79,292.68l-1.41,2.45a6.7,6.7,0,0,0-3.17-.89V291.4A9.62,9.62,0,0,1,647.79,292.68Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "645.5px 293.265px"
    },
    id: "el64witysrbux",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634.66,296.18l.08-.13-.08.14Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "634.7px 296.12px"
    },
    id: "el4784en6d2by",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634.74,296.05a9.33,9.33,0,0,1,1.43-1.82A9.64,9.64,0,0,0,634.74,296.05Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "635.455px 295.14px"
    },
    id: "eld5p8pfyusbc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.17,294.23a6.67,6.67,0,0,1,.68-.62C636.62,293.81,636.39,294,636.17,294.23Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "636.51px 293.92px"
    },
    id: "el0la9kec2z78l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.85,293.61a9.85,9.85,0,0,1,2.39-1.45A9.85,9.85,0,0,0,636.85,293.61Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "638.045px 292.885px"
    },
    id: "eld7t5b30g0tk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.24,292.16a8.44,8.44,0,0,1,1.34-.45A10,10,0,0,0,639.24,292.16Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "639.91px 291.935px"
    },
    id: "elllfqco7glw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M642.78,291.4h0a9.41,9.41,0,0,0-2.2.3A9.42,9.42,0,0,1,642.78,291.4Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "641.68px 291.55px"
    },
    id: "el4hqseb929zv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M642.78,291.41v2.83h-.14l-.31,0h0c-.23,0-.46.06-.68.1l-.33.08-.25.07-.08,0-.31.11h0l-.29.12a6.62,6.62,0,0,0-.88.45,5.25,5.25,0,0,0-.49.33.94.94,0,0,0-.12.09l-.14.1-.24.2s0,0,0,0a3.45,3.45,0,0,0-.28.26l0,0-.25.27,0,0c-.08.1-.17.2-.24.3s-.17.23-.25.35h0c-.08.12-.16.24-.23.36l-.2.37,0,0c0,.09-.09.19-.13.29l0,0-.09.2a1.34,1.34,0,0,1-.07.18c0,.1-.07.21-.1.32s-.07.23-.1.35,0,.2-.07.3,0,.17,0,.26,0,.09,0,.14,0,.1,0,.15a1.79,1.79,0,0,0,0,.23.86.86,0,0,0,0,.16,3,3,0,0,0,0,.31h-2.83a9.52,9.52,0,0,1,1.12-4.38c.06-.13.13-.25.2-.37l.08-.14a9.64,9.64,0,0,1,1.43-1.82c.22-.22.45-.42.68-.62a9.85,9.85,0,0,1,2.39-1.45,10,10,0,0,1,1.34-.45h0A9.41,9.41,0,0,1,642.78,291.41Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "638.23px 296.038px"
    },
    id: "el8jfq4v47jxi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634.45,296.56h0a9.52,9.52,0,0,0-1.12,4.38h0A9.61,9.61,0,0,1,634.45,296.56Z",
    style: {
      fill: "rgb(199, 199, 199)",
      transformOrigin: "633.89px 298.75px"
    },
    id: "elfie19vrcz6u",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.19,306.72l-1.42,2.46a9.64,9.64,0,0,1-4.43-7.82h2.84A6.81,6.81,0,0,0,639.19,306.72Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "636.265px 305.27px"
    },
    id: "ellckw7jy1oh8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M650.92,306.56a9.62,9.62,0,0,1-7.93,4.15,9.49,9.49,0,0,1-4.85-1.31l1.42-2.45a6.82,6.82,0,0,0,8.9-1.81Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "644.53px 307.925px"
    },
    id: "elwmrm0559jvn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.52,301.14l-1.23,1h1.23a.09.09,0,0,1,.1.09.1.1,0,0,1-.1.1H638a.12.12,0,0,1-.08,0,.09.09,0,0,1,0-.13l1.45-1.13a.83.83,0,0,0,.33-.64.53.53,0,0,0-.56-.55.79.79,0,0,0-.5.18l-.15.12a.09.09,0,0,1-.13,0,.09.09,0,0,1,0-.13l.15-.12a1,1,0,0,1,.62-.22.75.75,0,0,1,.61.29.73.73,0,0,1,.14.45A1.05,1.05,0,0,1,639.52,301.14Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "638.886px 301.023px"
    },
    id: "eljq5lufaoed",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M642,299.92a1.21,1.21,0,0,1,.19.71,2,2,0,0,1,0,.34l-.09,0,.09,0a2,2,0,0,1-.42.92,1,1,0,0,1-.72.4h0a.66.66,0,0,1-.54-.31,1.29,1.29,0,0,1-.19-.71,1.84,1.84,0,0,1,0-.33,2,2,0,0,1,.42-.93,1,1,0,0,1,.72-.4A.66.66,0,0,1,642,299.92Zm0,.71a1.1,1.1,0,0,0-.16-.61.47.47,0,0,0-.39-.22.82.82,0,0,0-.58.33,1.81,1.81,0,0,0-.38.84,1.51,1.51,0,0,0,0,.3,1.1,1.1,0,0,0,.16.61.45.45,0,0,0,.39.22.82.82,0,0,0,.58-.33,1.82,1.82,0,0,0,.38-.83A1.67,1.67,0,0,0,642,300.63Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "641.255px 300.95px"
    },
    id: "elotzu57roin",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.68,299.92a1.21,1.21,0,0,1,.19.71,2,2,0,0,1,0,.34l-.09,0,.09,0a1.86,1.86,0,0,1-.42.92,1,1,0,0,1-.72.4h0a.63.63,0,0,1-.54-.31,1.22,1.22,0,0,1-.2-.71c0-.11,0-.22,0-.33a2,2,0,0,1,.43-.93,1,1,0,0,1,.72-.4A.63.63,0,0,1,644.68,299.92Zm0,.71a1.1,1.1,0,0,0-.16-.61.47.47,0,0,0-.39-.22.82.82,0,0,0-.58.33,1.81,1.81,0,0,0-.38.84,1.53,1.53,0,0,0,0,.3,1.1,1.1,0,0,0,.16.61.45.45,0,0,0,.39.22.82.82,0,0,0,.58-.33,1.82,1.82,0,0,0,.38-.83A1.71,1.71,0,0,0,644.69,300.63Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "643.933px 300.95px"
    },
    id: "el1ebp7b2qi2i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M646.46,299.72l-.27,1.53,1.9-1.62a.09.09,0,1,1,.12.14l-1.22,1,.86,1.33a.09.09,0,0,1,0,.13h-.05a.09.09,0,0,1-.08,0l-.85-1.31-.71.6h0l-.12.68a.1.1,0,0,1-.09.07h0a.09.09,0,0,1-.07-.11l.43-2.48a.09.09,0,0,1,.11-.08A.1.1,0,0,1,646.46,299.72Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "647.06px 300.934px"
    },
    id: "el1s5uj306o8j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M646.22,152h-.75v-.91h.75Zm0-2.91h-.75v-2h.75Zm0-4h-.75v-2h.75Zm0-4h-.75v-2h.75Zm0-4h-.75v-2h.75Zm-2.1-1.91h-2v-.75h2Zm-4,0h-2v-.75h2Zm-4,0h-2v-.75h2Zm-4,0h-2v-.75h2Zm-4,0h-2v-.75h2Zm-4,0h-2v-.75h2Zm-4,0h-2v-.75h2Zm-4,0h-2v-.75h2Zm-4,0h-2v-.75h2Zm-4,0h-2v-.75h2Zm-4,0h-2v-.75h2Zm-4,0h-2v-.75h2Zm-4,0h-2v-.75h2Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "620.17px 143.215px"
    },
    id: "elifopmtyb4j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "644.35 151.6 645.85 154.19 647.34 151.6 644.35 151.6",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "645.845px 152.895px"
    },
    id: "el1avq16smvk3",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Folder--inject-517",
    className: "animable",
    style: {
      transformOrigin: "108.425px 238.535px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108.41,301.84h-.75v-2h.75Zm0-4h-.75v-2h.75Zm0-4h-.75v-2h.75Zm0-4h-.75v-2h.75Zm0-4h-.75v-2h.75Zm0-4h-.75v-2h.75Zm0-4h-.75v-2h.75Zm0-4h-.75v-2h.75Zm0-4h-.75v-2h.75Zm0-4h-.75v-2h.75Zm0-4h-.75v-2h.75Zm0-4h-.75v-2h.75Zm0-4h-.75v-2h.75Zm0-4h-.75v-2h.75Zm0-4h-.75v-2h.75Zm0-4h-.75v-2h.75Zm0-4h-.75v-2h.75Zm0-4h-.75v-2h.75Zm0-4h-.75v-2h.75Zm0-4h-.75v-2h.75Zm0-4h-.75v-2h.75Zm0-4h-.75v-2h.75Zm0-4h-.75v-2h.75Zm0-4h-.75v-2h.75Zm0-4h-.75v-2h.75Zm0-4h-.75v-2h.75Zm0-4h-.75v-2h.75Zm0-4h-.75v-2h.75Zm0-4h-.75v-2h.75Zm0-4h-.75v-2h.75Zm0-4h-.75v-2h.75Zm0-4h-.75v-1.49h1.26v.75h-.51Zm40.51-.74h-2v-.75h2Zm-4,0h-2v-.75h2Zm-4,0h-2v-.75h2Zm-4,0h-2v-.75h2Zm-4,0h-2v-.75h2Zm-4,0h-2v-.75h2Zm-4,0h-2v-.75h2Zm-4,0h-2v-.75h2Zm-4,0h-2v-.75h2Zm-4,0h-2v-.75h2Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "128.29px 239.095px"
    },
    id: "el6honb8bbie8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "150.22 178.22 152.81 176.73 150.22 175.23 150.22 178.22",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "151.515px 176.725px"
    },
    id: "elr92gmvvet8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "138.14 260.19 77.03 260.19 84.84 215.9 145.94 215.9 138.14 260.19",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "111.485px 238.045px"
    },
    id: "elvwqnygek9n9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "107.24 211.32 85.65 211.32 84.84 215.9 107.67 215.9 107.24 211.32",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "96.255px 213.61px"
    },
    id: "elx0cut9g6ao",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el5ufbt7zocar"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2,
      transformOrigin: "111.485px 235.755px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "138.14 260.19 77.03 260.19 84.84 215.9 145.94 215.9 138.14 260.19",
    id: "elr8eswaaw2eb",
    className: "animable",
    style: {
      transformOrigin: "111.485px 238.045px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "107.24 211.32 85.65 211.32 84.84 215.9 107.67 215.9 107.24 211.32",
    id: "el7r7635kd9da",
    className: "animable",
    style: {
      transformOrigin: "96.255px 213.61px"
    }
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "104.72 215.37 87.06 215.37 87.53 212.7 105.19 212.7 104.72 215.37",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "96.125px 214.035px"
    },
    id: "eld9gr98s67c7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "els762865ftfr"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 79.25,
    y: 212.83,
    width: 56.84,
    height: 44.28,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "107.67px 234.97px",
      transform: "rotate(-2.78deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "92.26 253.03 91.38 235.76 90.58 218.49 91.47 235.76 92.26 253.03",
    style: {
      fill: "rgb(199, 199, 199)",
      transformOrigin: "91.42px 235.76px"
    },
    id: "elycgqnio7vn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "93.67 252.97 92.79 235.69 91.99 218.42 92.87 235.69 93.67 252.97",
    style: {
      fill: "rgb(199, 199, 199)",
      transformOrigin: "92.83px 235.695px"
    },
    id: "elcvzcw9txo8u",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "95.08 252.9 94.19 235.63 93.4 218.35 94.28 235.62 95.08 252.9",
    style: {
      fill: "rgb(199, 199, 199)",
      transformOrigin: "94.24px 235.625px"
    },
    id: "elmyuj1c8hv0a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "96.49 252.83 95.6 235.56 94.81 218.28 95.69 235.55 96.49 252.83",
    style: {
      fill: "rgb(199, 199, 199)",
      transformOrigin: "95.65px 235.555px"
    },
    id: "elyijf9kml1zd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "97.89 252.76 97.01 235.49 96.22 218.21 97.1 235.49 97.89 252.76",
    style: {
      fill: "rgb(199, 199, 199)",
      transformOrigin: "97.055px 235.485px"
    },
    id: "ela19gvr6x6ww",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "99.3 252.69 98.42 235.42 97.63 218.14 98.51 235.42 99.3 252.69",
    style: {
      fill: "rgb(199, 199, 199)",
      transformOrigin: "98.465px 235.415px"
    },
    id: "el62p3lfujz5k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "100.71 252.63 99.83 235.35 99.04 218.07 99.92 235.35 100.71 252.63",
    style: {
      fill: "rgb(199, 199, 199)",
      transformOrigin: "99.875px 235.35px"
    },
    id: "el8ua9wt8dt8n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "102.12 252.56 101.24 235.28 100.44 218.01 101.33 235.28 102.12 252.56",
    style: {
      fill: "rgb(199, 199, 199)",
      transformOrigin: "101.28px 235.285px"
    },
    id: "eluc4dxqtswlc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "103.53 252.49 102.65 235.22 101.85 217.94 102.74 235.21 103.53 252.49",
    style: {
      fill: "rgb(199, 199, 199)",
      transformOrigin: "102.69px 235.215px"
    },
    id: "eln61bsnw2idh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "104.94 252.42 104.06 235.15 103.26 217.87 104.14 235.14 104.94 252.42",
    style: {
      fill: "rgb(199, 199, 199)",
      transformOrigin: "104.1px 235.145px"
    },
    id: "elqlsv094zxu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "106.35 252.35 105.47 235.08 104.67 217.8 105.55 235.07 106.35 252.35",
    style: {
      fill: "rgb(199, 199, 199)",
      transformOrigin: "105.51px 235.075px"
    },
    id: "elgvphdoidt0f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "107.76 252.28 106.88 235.01 106.08 217.73 106.96 235.01 107.76 252.28",
    style: {
      fill: "rgb(199, 199, 199)",
      transformOrigin: "106.92px 235.005px"
    },
    id: "elnivpdwv5n0p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "109.17 252.22 108.28 234.94 107.49 217.66 108.37 234.94 109.17 252.22",
    style: {
      fill: "rgb(199, 199, 199)",
      transformOrigin: "108.33px 234.94px"
    },
    id: "ela5o6mpzru6u",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "110.57 252.15 109.69 234.87 108.9 217.6 109.78 234.87 110.57 252.15",
    style: {
      fill: "rgb(199, 199, 199)",
      transformOrigin: "109.735px 234.875px"
    },
    id: "elrzele46uwyn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "111.98 252.08 111.1 234.81 110.31 217.53 111.19 234.8 111.98 252.08",
    style: {
      fill: "rgb(199, 199, 199)",
      transformOrigin: "111.145px 234.805px"
    },
    id: "el7rjlq4legcx",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eles50yo26ae"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 109.12,
    y: 244.22,
    width: 2.62,
    height: 5.92,
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "110.43px 247.18px",
      transform: "rotate(-92.78deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "eljcfnd7ipdjd"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 107.3,
    y: 237.86,
    width: 2.62,
    height: 9.08,
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "108.61px 242.4px",
      transform: "rotate(-92.78deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el0fss2lo8u4p"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 105.3,
    y: 231.31,
    width: 2.62,
    height: 12.61,
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "106.61px 237.615px",
      transform: "rotate(-92.78deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el7g14qkf75yn"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 104.31,
    y: 225.73,
    width: 2.62,
    height: 14.13,
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "105.62px 232.795px",
      transform: "rotate(-92.8624deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ellizsyuw0cym"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 102.72,
    y: 219.58,
    width: 2.62,
    height: 16.84,
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "104.03px 228px",
      transform: "rotate(-92.78deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "els9d46tcfc2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 101.15,
    y: 213.45,
    width: 2.62,
    height: 19.51,
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "102.46px 223.205px",
      transform: "rotate(-92.78deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M91.22,252.15l5.59-.34,5.59-.32c3.72-.21,7.45-.4,11.17-.59l-.15.17-.42-8.4-.38-8.41-.36-8.4-.31-8.41.5,8.4.46,8.4.43,8.4.4,8.4v.17h-.16c-3.73.18-7.45.35-11.18.5l-5.59.22Z",
    style: {
      fill: "rgb(199, 199, 199)",
      transformOrigin: "102.48px 234.8px"
    },
    id: "elzdplr3yesuq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elimu4boto0y"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 113.37,
    y: 246.85,
    width: 2.62,
    height: 0.24,
    style: {
      fill: "rgb(199, 199, 199)",
      transformOrigin: "114.68px 246.97px",
      transform: "rotate(-92.78deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el8u5ubgeszbb"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 113.14,
    y: 241.99,
    width: 2.62,
    height: 0.24,
    style: {
      fill: "rgb(199, 199, 199)",
      transformOrigin: "114.45px 242.11px",
      transform: "rotate(-92.8624deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elzed3fb0bb2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 112.9,
    y: 237.13,
    width: 2.62,
    height: 0.24,
    style: {
      fill: "rgb(199, 199, 199)",
      transformOrigin: "114.21px 237.25px",
      transform: "rotate(-92.78deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elj21v9uv9t4b"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 112.67,
    y: 232.27,
    width: 2.62,
    height: 0.24,
    style: {
      fill: "rgb(199, 199, 199)",
      transformOrigin: "113.98px 232.39px",
      transform: "rotate(-92.78deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el5quptv5ymxb"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 112.43,
    y: 227.41,
    width: 2.62,
    height: 0.24,
    style: {
      fill: "rgb(199, 199, 199)",
      transformOrigin: "113.74px 227.53px",
      transform: "rotate(-92.78deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elb1skfxisx1h"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 112.19,
    y: 222.55,
    width: 2.62,
    height: 0.24,
    style: {
      fill: "rgb(199, 199, 199)",
      transformOrigin: "113.5px 222.67px",
      transform: "rotate(-92.78deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M108.27,248.3a32.51,32.51,0,0,0-.48-3.81,36.82,36.82,0,0,0-.86-3.74,32.73,32.73,0,0,0-2.89-7.07,25.74,25.74,0,0,0-4.58-6.09l-.34-.34-.36-.31-.71-.64c-.51-.39-1-.81-1.53-1.16a27.27,27.27,0,0,0-3.28-2v0a22.87,22.87,0,0,1,6.41,4.25,22.1,22.1,0,0,1,2.59,2.88,25.78,25.78,0,0,1,2.12,3.24,30.84,30.84,0,0,1,2.83,7.18A31.69,31.69,0,0,1,108.27,248.3Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "100.755px 235.72px"
    },
    id: "elqxyaz7dabdr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "95.03 222.32 95.14 222.68 93.37 223.21 94.03 224.93 93.68 225.07 92.88 222.97 95.03 222.32",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "94.01px 223.695px"
    },
    id: "elpte0kinazi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elnxac3ei1hh"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 104.27,
    y: 233.53,
    width: 36.07,
    height: 1.46,
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "122.305px 234.26px",
      transform: "rotate(87.22deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el19giny0hpgy"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 116.21,
    y: 241.23,
    width: 20.31,
    height: 1.46,
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "126.365px 241.96px",
      transform: "rotate(87.22deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el01xrykkazssk"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 76.14,
    y: 235.28,
    width: 20.31,
    height: 1.46,
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "86.295px 236.01px",
      transform: "rotate(87.22deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "138.25 260.19 77.15 260.19 65.27 219.58 126.38 219.58 138.25 260.19",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "101.76px 239.885px"
    },
    id: "elybhfc7xjace",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "85.63 215.37 64.04 215.37 65.27 219.58 88.1 219.58 85.63 215.37",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "76.07px 217.475px"
    },
    id: "elk18ecbzn3h8",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--magnifying-glass--inject-517",
    className: "animable",
    style: {
      transformOrigin: "459.754px 212.419px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "el5zkqdk4gb3l"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 484.48,
    y: 218.55,
    width: 13.24,
    height: 52.09,
    style: {
      fill: "rgb(199, 199, 199)",
      transformOrigin: "491.1px 244.595px",
      transform: "rotate(138deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "530.86 303.73 545.74 290.33 545.74 290.33 509.64 250.23 509.64 250.23 494.76 263.63 494.76 263.63 530.86 303.73",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "520.25px 276.98px"
    },
    id: "eljgf39bsvor",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.63,192.46l-.06.3-.09.46c-.11.57-.22,1.13-.35,1.67,0,.18-.08.35-.13.52a49.64,49.64,0,0,1-2.61,7.92c-.08.2-.16.4-.25.59a50.93,50.93,0,0,1-4.94,8.82l-.24.34a51.76,51.76,0,0,1-16.16,14.75l-.42.25A52.26,52.26,0,0,1,449.5,233l-1.56.41a50.76,50.76,0,0,1-15.32,1.34l-.36,0a52.32,52.32,0,0,1-6.39-.85c-.68-.13-1.36-.28-2-.45s-1.19-.3-1.78-.46A51.08,51.08,0,0,1,407,226.06c-.24-.16-.5-.33-.74-.51-.94-.65-1.85-1.34-2.74-2.06l-.46-.38a51.15,51.15,0,0,1-9.24-9.94l-.37-.52c-.16-.22-.31-.45-.46-.67a52.16,52.16,0,0,1-6.12-12.42c-.11-.32-.21-.64-.31-1a53.39,53.39,0,0,1-1.45-5.73c0-.18-.06-.35-.1-.53a51.74,51.74,0,0,1,.19-19.09l.14-.68.12-.53a51.18,51.18,0,0,1,12.41-23.77,52.64,52.64,0,0,1,9.25-7.9Q409,139.11,411,138a51.68,51.68,0,0,1,75.3,34.12,1.59,1.59,0,0,1,.06.3A51.2,51.2,0,0,1,486.63,192.46Z",
    style: {
      fill: "rgb(219, 219, 219)",
      transformOrigin: "435.852px 183.246px"
    },
    id: "el0h2i2u2xqe24",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.63,192.46l-.06.3-.09.46c-.11.57-.22,1.13-.35,1.67,0,.18-.08.35-.13.52a49.64,49.64,0,0,1-2.61,7.92c-.08.2-.16.4-.25.59a50.93,50.93,0,0,1-4.94,8.82l-.24.34a51.76,51.76,0,0,1-16.16,14.75l-.42.25A52.26,52.26,0,0,1,449.5,233l-1.56.41a50.76,50.76,0,0,1-15.32,1.34l-.36,0a52.32,52.32,0,0,1-6.39-.85c-.68-.13-1.36-.28-2-.45s-1.19-.3-1.78-.46A51.08,51.08,0,0,1,407,226.06c-.24-.16-.5-.33-.74-.51-.94-.65-1.85-1.34-2.74-2.06l-.46-.38a51.15,51.15,0,0,1-9.24-9.94l-.37-.52c-.16-.22-.31-.45-.46-.67a52.16,52.16,0,0,1-6.12-12.42c-.11-.32-.21-.64-.31-1a53.39,53.39,0,0,1-1.45-5.73c0-.18-.06-.35-.1-.53a51.74,51.74,0,0,1,.19-19.09l.14-.68.12-.53a51.18,51.18,0,0,1,12.41-23.77,52.64,52.64,0,0,1,9.25-7.9Q409,139.11,411,138a51.68,51.68,0,0,1,75.3,34.12,1.59,1.59,0,0,1,.06.3A51.2,51.2,0,0,1,486.63,192.46Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "435.852px 183.246px"
    },
    id: "el85zo2op6gq3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.63,192.46l-.06.3-.09.46c-.11.57-.22,1.13-.35,1.67,0,.18-.08.35-.13.52a49.64,49.64,0,0,1-2.61,7.92c-.08.2-.16.4-.25.59a50.93,50.93,0,0,1-4.94,8.82l-.24.34a51.76,51.76,0,0,1-16.16,14.75l-.42.25A52.26,52.26,0,0,1,449.5,233l-1.56.41a50.76,50.76,0,0,1-15.32,1.34l-.36,0a52.32,52.32,0,0,1-6.39-.85c-.68-.13-1.36-.28-2-.45s-1.19-.3-1.78-.46A51.08,51.08,0,0,1,407,226.06c-.24-.16-.5-.33-.74-.51-.94-.65-1.85-1.34-2.74-2.06l-.46-.38a51.15,51.15,0,0,1-9.24-9.94l-.37-.52c-.16-.22-.31-.45-.46-.67a52.16,52.16,0,0,1-6.12-12.42c-.11-.32-.21-.64-.31-1a53.39,53.39,0,0,1-1.45-5.73c0-.18-.06-.35-.1-.53a51.74,51.74,0,0,1,.19-19.09l.14-.68.12-.53a51.18,51.18,0,0,1,12.41-23.77,52.64,52.64,0,0,1,9.25-7.9Q409,139.11,411,138H460.8a50.8,50.8,0,0,1,13,10.24,52.14,52.14,0,0,1,12.47,23.88,1.59,1.59,0,0,1,.06.3A51.2,51.2,0,0,1,486.63,192.46Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "435.845px 186.428px"
    },
    id: "el6hoazka66le",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.8,148.27H397.87a52.64,52.64,0,0,1,9.25-7.9Q409,139.11,411,138H460.8A50.8,50.8,0,0,1,473.8,148.27Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "435.835px 143.135px"
    },
    id: "el7zyr5ua17yk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.56,213.16v1l0,9.29-.46-.38,0-8.91v-1.55l.05-11.85v-8.45l0-9.57.13-10.22.14,10.22,0,9.57v8.45l.05,11.85Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "403.33px 197.985px"
    },
    id: "el47wduc8lc3x",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.71,214.2,432.63,233v1.77l-.36,0V233l-.09-18.79v-1.51l0-5.73v-5.9l0-2.69v-6l0-9.61.14-10.26.13,10.26.05,9.61v6l0,2.69V207l0,5.73v1.51Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "432.445px 203.64px"
    },
    id: "elnhsrtw2oxpk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.85,213.1v1.1l-.05,13.63-.42.25-.06-13.88V203.48l0-8V189.5l0-6.72.13-10.29.13,10.29,0,6.72v5.93l0,8v9.62Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "461.585px 200.285px"
    },
    id: "el1rxjzrbxpdwj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.33,172.45l-14.29,0H461.59l-29.15,0-29.16,0H385.34l.12-.53,86.58.08,14.23,0A1.59,1.59,0,0,1,486.33,172.45Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "435.835px 172.185px"
    },
    id: "elstjrp1nblt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.63,192.46l-.06.3-14.53,0H458.63l-24.73,0H431l-27.5,0H385.11c0-.18-.06-.35-.1-.53h18.45l28.8,0h.36l26,0H472Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "435.82px 192.495px"
    },
    id: "eluhxavy3x8k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.2,212.74l-.24.34H461.32l-28.62,0h-.53l-14.24,0H393.82l-.37-.52h10.1l13.66,0h1.13l13.83,0h.53l28.62,0H478.2Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "435.825px 212.82px"
    },
    id: "elmubejnulcl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.5,233l-1.56.41h-24.1c-.6-.14-1.19-.3-1.78-.46h10.57Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "435.78px 233.18px"
    },
    id: "ell4en3ccc72i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.13,194.89c0,.18-.08.35-.13.52l-21.55-2.19-.54-.05-.55-.06-1.59-.16h-.13l-.23.09-1.37.52-.52.2-.51.2-14.48,5.59-1,.39-8.22,3.17-.51.2-.51.2-1.59.6-.08,0-.11,0-.11,0-.15,0-1.64-.34-.54-.1-.53-.11-3-.6-.91-.19-19.54-4-.54-.1-.54-.12-1.52-.31-.22,0-.18,0-1.61.14-.55,0-.54,0-13.52,1.08c-.11-.32-.21-.64-.31-1l13.78-1,.54-.05.55,0,1.66-.13h.29l.11,0,1.68.36.55.1.53.11,20,4.16.9.18,2.59.54.55.11.55.12,1.38.28.2.05.25-.11,1.23-.46.53-.21.51-.18,7.51-2.86,1.05-.4,15.26-5.81.51-.2.5-.19.38-.15,1-.38.26-.1.06,0,.07,0h.08l.15,0,1.18.12.53.06.53.05.53.06,1.91.21Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "436.345px 198.175px"
    },
    id: "elcr7ixbjk00m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.87,204a2.43,2.43,0,1,1-2.43-2.43A2.43,2.43,0,0,1,434.87,204Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "432.44px 204px"
    },
    id: "el86ifw0zkrvc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.27,203.1a3.4,3.4,0,0,0-.34-.69,2.91,2.91,0,0,0-2.28-1.35h-.43a2.92,2.92,0,0,0-2.49,1.75,2.54,2.54,0,0,0-.23.77,2.12,2.12,0,0,0,0,.44,3,3,0,0,0,2.73,2.94,1,1,0,0,0,.25,0,.93.93,0,0,0,.24,0,3,3,0,0,0,2.73-2.94A3.16,3.16,0,0,0,435.27,203.1Zm-2.6,2.79-.23,0-.24,0a1.89,1.89,0,0,1-1.65-1.87,2.08,2.08,0,0,1,.28-1,1.89,1.89,0,0,1,1.39-.91h.43a1.91,1.91,0,0,1,1.24.67,1.87,1.87,0,0,1,.36.7,1.81,1.81,0,0,1,.07.52A1.88,1.88,0,0,1,432.67,205.89Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "432.469px 204.014px"
    },
    id: "el7coj5pm88v",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.72,197.84a2.43,2.43,0,1,1-2.43-2.43A2.43,2.43,0,0,1,405.72,197.84Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "403.29px 197.84px"
    },
    id: "elv5j3xsyhldm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.48,194.87h-.38a3,3,0,0,0-2.76,2.69,1.27,1.27,0,0,0,0,.28,3.39,3.39,0,0,0,.07.64,3,3,0,0,0,2.69,2.32h.42a3,3,0,0,0,2.59-2,2.65,2.65,0,0,0,.16-.89.28.28,0,0,0,0-.09A3,3,0,0,0,403.48,194.87Zm1.7,3a1.76,1.76,0,0,1-.17.76,1.89,1.89,0,0,1-1.51,1.12h-.42a1.91,1.91,0,0,1-1.6-1.32,2,2,0,0,1-.08-.56,2.31,2.31,0,0,1,0-.37A1.91,1.91,0,0,1,403.1,196h.38a1.87,1.87,0,0,1,1.69,1.76A.45.45,0,0,1,405.18,197.84Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "403.303px 197.835px"
    },
    id: "eleuhmkubiiis",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464,192.47a2.43,2.43,0,1,1-2.43-2.43A2.43,2.43,0,0,1,464,192.47Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "461.57px 192.47px"
    },
    id: "elb57z2mxj91n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.75,189.5h-.32a3,3,0,0,0-2.81,2.92v.05c0,.11,0,.22,0,.33a2.36,2.36,0,0,0,.12.54,2.73,2.73,0,0,0,.26.61,3,3,0,0,0,2.39,1.48h.38a3,3,0,0,0,2.67-2.21,2,2,0,0,0,.08-.42,1.41,1.41,0,0,0,0-.21.49.49,0,0,0,0-.12v-.05A3,3,0,0,0,461.75,189.5Zm1.73,3a1.73,1.73,0,0,1,0,.32,1.4,1.4,0,0,1-.09.31,1.9,1.9,0,0,1-1.59,1.24h-.37a1.89,1.89,0,0,1-1.36-.8,1.65,1.65,0,0,1-.28-.6.66.66,0,0,1,0-.15,1.84,1.84,0,0,1,0-.33v-.05a1.89,1.89,0,0,1,1.73-1.83h.34a1.9,1.9,0,0,1,1.72,1.83Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "461.572px 192.465px"
    },
    id: "el143btw0udl7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.39,203.33c-.08.2-.16.4-.25.59l-18.6,2.36-.53.06-.53.07-1.66.2-.19,0h-.08l-.07,0-.13,0-1.6-.6-.5-.19-.51-.18-15.25-5.68-1.05-.38-7.38-2.75-.51-.19-.52-.2-1.4-.52-.07,0-.31.37-.7.82h0l-.35.43-.35.41-3.7,4.37-.6.71-8.2,9.69-.41.48L407,226.06c-.24-.16-.5-.33-.74-.51l10.56-12.4.39-.48,8.42-9.88.61-.7,4-4.7.35-.42.37-.42,1.18-1.4.12-.13.06-.08.27.1h.05l1.68.64.51.19.51.19,8.16,3.08,1,.39L459,205l.51.19.52.2,1.32.5.28.1.19,0,1.52-.17.55-.07.55-.07Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "444.825px 210.5px"
    },
    id: "elnab762bmbj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.87,195.41a2.43,2.43,0,1,1-2.43-2.43A2.43,2.43,0,0,1,434.87,195.41Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "432.44px 195.41px"
    },
    id: "elwh9x7t5ktf8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.9,192.83a2.9,2.9,0,0,0-1.28-.38h-.36a3,3,0,0,0-2,4.94,2.67,2.67,0,0,0,.61.51,2.75,2.75,0,0,0,1.4.47h.39a3,3,0,0,0,2.43-1.57,2.67,2.67,0,0,0,.27-.73,2.93,2.93,0,0,0-1.43-3.24Zm.41,2.86a1.81,1.81,0,0,1-.28.72,1.88,1.88,0,0,1-1.4.88h-.39a1.66,1.66,0,0,1-.69-.23h0a1.53,1.53,0,0,1-.59-.51,1.82,1.82,0,0,1-.4-1.15,1.89,1.89,0,0,1,1.71-1.87h.36a1.88,1.88,0,0,1,1.7,1.87C434.32,195.5,434.31,195.59,434.31,195.69Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "432.488px 195.41px"
    },
    id: "elel4r897dph",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464,206.45a2.43,2.43,0,1,1-2.43-2.43A2.43,2.43,0,0,1,464,206.45Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "461.57px 206.45px"
    },
    id: "elaw77ulsigu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.54,206.28a2.67,2.67,0,0,0-.1-.64,3,3,0,0,0-2.63-2.16h-.45A3,3,0,0,0,459,205a2.62,2.62,0,0,0-.26.62,2.55,2.55,0,0,0-.12.84,3,3,0,0,0,2.71,3,1.14,1.14,0,0,0,.26,0,1,1,0,0,0,.24,0,3,3,0,0,0,2.72-3A.91.91,0,0,0,464.54,206.28Zm-1.06.17a1.87,1.87,0,0,1-1.66,1.86l-.23,0-.25,0a1.87,1.87,0,0,1-1.65-1.86,1.73,1.73,0,0,1,.06-.47,1.93,1.93,0,0,1,.28-.6,1.8,1.8,0,0,1,1.33-.8.9.9,0,0,1,.23,0,.93.93,0,0,1,.23,0,1.83,1.83,0,0,1,1.52,1.2,1.62,1.62,0,0,1,.14.63Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "461.585px 206.474px"
    },
    id: "elnr7e6gwaky",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.17,242.43A60.34,60.34,0,1,1,495,194.91,60.4,60.4,0,0,1,424.17,242.43Zm1.34-6.79a53.41,53.41,0,1,0-42.07-62.74A53.46,53.46,0,0,0,425.51,235.64Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "435.803px 183.217px"
    },
    id: "elhse5lp5wpie",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.48,170.06a55.58,55.58,0,0,0-7.79-17.56A55.19,55.19,0,1,0,390,214a55.18,55.18,0,0,0,100-20.06A54.77,54.77,0,0,0,489.48,170.06Zm-3,23.16a51.68,51.68,0,1,1-7.79-38.72A51.69,51.69,0,0,1,486.49,193.22Zm3-23.16a55.58,55.58,0,0,0-7.79-17.56A55.19,55.19,0,1,0,390,214a55.18,55.18,0,0,0,100-20.06A54.77,54.77,0,0,0,489.48,170.06Zm-3,23.16a51.68,51.68,0,1,1-7.79-38.72A51.69,51.69,0,0,1,486.49,193.22Zm9.7-24.81a62.1,62.1,0,1,0,.61,26.84A62,62,0,0,0,496.19,168.41Zm-2.91,26.15a58.56,58.56,0,1,1-.59-25.29A58.22,58.22,0,0,1,493.28,194.56ZM481.69,152.5A55.19,55.19,0,1,0,390,214a55.18,55.18,0,0,0,100-20.06,54.77,54.77,0,0,0-.53-23.85A55.58,55.58,0,0,0,481.69,152.5Zm4.8,40.72a51.68,51.68,0,1,1-7.79-38.72A51.69,51.69,0,0,1,486.49,193.22Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "435.872px 183.208px"
    },
    id: "elt5judn42js",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eltzapbfsxu2"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      transformOrigin: "435.835px 183.294px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M478.72,154.49a51.66,51.66,0,1,1-32.89-21.88A51.68,51.68,0,0,1,478.72,154.49Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "435.835px 183.294px"
    },
    id: "elxfkkhkk4lg",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M415.38,147a39.45,39.45,0,0,1,15.42-5.62,41.28,41.28,0,0,1,8.4-.45,43.81,43.81,0,0,1,8.42,1.26,41.15,41.15,0,0,1,15.22,7.64,45.6,45.6,0,0,1,11,12.71A81.81,81.81,0,0,0,461.27,152a50.1,50.1,0,0,0-7-3.82,41.46,41.46,0,0,0-7.45-2.62,50.56,50.56,0,0,0-15.66-1.5A66.47,66.47,0,0,0,415.38,147Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "444.61px 151.711px"
    },
    id: "elgp0v70sitte",
    className: "animable"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "active",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#32DFEC",
    floodOpacity: 1,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "hover",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ff0000",
    floodOpacity: 0.5,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0   0   0   0   0                0   1   0   0   0                0   0   0   0   0                0   0   0   1   0 "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComputer);
export default __webpack_public_path__ + "static/media/computer.e48150db6907a2998c9e99bba232f451.svg";
export { ForwardRef as ReactComponent };